<template>
<div id="vy_body">
  <div id="vy_grid" >
    <div id="vy_left_nav" class="p-4">
      <!--左サイドバー-->
          <component v-bind:is="contentLeft"
                    v-if="displayStatus_left"
                    v-bind:param="param_left"
                    v-on:call="call"/>
    </div>


    <span class="sp_only">
        <div id="sp-header" >

            <span style="width:85%;cursor: pointer;height: 100%;display: flex;align-items: center;" v-on:click="Smart_home()">
                <img v-if="header_logo" id="by-logo" v-bind:src="header_logo" alt="ボラ活エール" style="height:90%;padding-right: 5px;" />
                <img v-else id="vy-logo" src="../../images/logo.png" alt="ボラ活エール" style="height:90%;padding-right: 5px;" />
                <div style="line-height: 1.1em;display:flex;flex-direction: column;text-align:left">
                    <b :style="title_style1_sp">{{ header_title1 }}</b>
                    <b :style="title_style2_sp">{{ header_title2 }}</b>
                </div>
            </span>
            <div style="width: 15%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-end;">
                
                <span v-if="GlobalData.$User_email" :onclick="move_notification" class="sp-icon">
                    <img src="../../images/alert_badge.png" v-if="midoku_count != 0">
                    <img src="../../images/alert_off.png" v-else >
                </span>
            </div>
        </div>
    </span>
    <!--公開終了メッセージ-->    <!-- class="ql-editor"は、QuillEditorのデータをv-htmlで表示する際に必要です。font-sizeに影響する -->
    <div v-if="kokai_end_flg == false" style="padding:50px 10px;text-align: center;" class="ql-editor" v-html="after_message">
    </div>
    
    <!--公開前メッセージ-->    <!-- class="ql-editor"は、QuillEditorのデータをv-htmlで表示する際に必要です。font-sizeに影響する -->
    <div v-else-if="kokai_flg == false" style="padding:50px 10px;text-align: center;" class="ql-editor" v-html="before_message">
    </div>
    
    <!--公開中-->
    <div id="vy_main" v-else-if="kokai_flg == true">
      <main>
        <component
                   v-bind:is="content"
                   v-bind:param="param"
                   v-on:call="call"
                   v-bind:key="render"
                   ref="comp">{{ title }}</component>
        <!--フッター-->
        <FooterArea v-on:call="call"/>
      </main>
    </div>
    <div id="vy_right_nav" class="p-4">
        <!--右サイドバー-->
        <component v-bind:is="contentRight" v-on:call="call"  v-if="displayStatus"/>
    </div>
  </div>
</div>

<div class="vy-responsive-menu-container" v-if="kokai_flg == true">
    <div class="vy-responsive-menu-button_left" v-on:click="Smart_home()">
        <img id="vy-logo" v-if="(route.params.cmd == '' || route.params.cmd == 'home' || route.params.cmd == null) && Smart_search_open==0" src="../../images/smart/icon_home_red.png" alt="HOME" />
        <img id="vy-logo" v-else src="../../images/smart/icon_home.png" alt="HOME" />
    </div>

    <div class="vy-responsive-menu-button_center" v-on:click="Smart_search()">
        <img id="vy-logo" v-if="route.params.cmd == 'Jizen'" src="../../images/smart/icon_search_gray.png" alt="検索" />
        <img id="vy-logo" v-else-if="Smart_search_open==1" src="../../images/smart/icon_search_red.png" alt="検索" />
        <img id="vy-logo" v-else src="../../images/smart/icon_search.png" alt="検索" />
    </div>

    <div v-bind:key="render_Smart" class="vy-responsive-menu-button_right" v-on:click="Smart_mypage()">
        
        <img id="vy-logo" v-if="route.params.cmd == 'mypage' && GlobalData.$User_email && Smart_search_open==0" src="../../images/smart/icon_mypage_red.png" alt="マイページ" />
        <img id="vy-logo" v-else-if="GlobalData.$User_email" src="../../images/smart/icon_mypage.png" alt="マイページ" />
        <img id="vy-logo" v-else src="../../images/smart/icon_login.png" alt="ログイン" />
    </div>
</div>


    <!--検索フォームを表示するウィンドウ（スマホ用）-->
    <component v-bind:is="contentSearchSmart"
                v-bind:param="param_left"
                v-on:call="call"/>
        
    <!--メッセージを表示するモーダルウィンドウ-->
    <component v-bind:is="contentMessage"
                v-bind:message_text="message"
                v-bind:message_cat="message_cat"
                v-bind:message_flag="message_flag"
                v-on:call="call"
                v-on:close_message="Close_message"
                v-on:ok_message="OK_message"/>

    <!-- 複数ユーザー対応  ユーザーを切り替える画面 -->
    <component v-bind:is="contentUserSwitch"
                v-bind:multipleprofile_switch_flg="multipleprofile_switch_flg"
                v-bind:user_id="user_id"
                v-bind:param_multiple="param_multiple"
                v-on:call="call"
                v-on:multipleprofile_close="multipleprofile_close"/>
    
    <!-- ローディングアイコンを表示するモーダルウィンドウ -->
    <LoadingModal v-if="loading_flg"/>
                
</template>

<script setup>
/* eslint-disable */
import UserJizenIchiran from './UserJizenIchiran.vue'
import UserPgIchiran from './UserPgIchiran.vue'
import UserPgShosai from './UserPgShosai.vue'
import UserPgLeftbar from './UserPgLeftBar.vue'
import UserLeftbar from './UserLeftBar.vue'
import UserPgMoshikomi from './UserPgMoshikomi.vue'
import UserJizenCode from './UserJizenCode.vue'
import UserTaikenCode from './userTaikenCode.vue'
import UserJigoCode from './UserJigoCode.vue'
import UserMypage from './UserMypage.vue'
import UserMyShosai from './UserMyShosai.vue'
import UserMyCode from './UserMyCode.vue'
import UserMySetting from './UserMySetting.vue'
import UserReport from './UserReport.vue'
import UserCheckin from './UserCheckin.vue'
import UserMyLeftbar from './UserMyLeftBar.vue'
import UserRenewal from './UserRenewal.vue'
import UserRenewalCode from './UserRenewalCode.vue'
import UserToroku from './UserToroku.vue'
import UserSignin from './UserSignin.vue'
import UserForm from './UserForm.vue'
import UserNotification from './UserNotification.vue'
import UserRightBar from './UserRightBar.vue'
import FooterArea from '../common/FooterArea.vue'
import UserMailLogin from './UserMailLogin.vue'
import UserMailRenewal from './UserMailRenewal.vue'
import UserMailRenewalCode from './UserMailRenewalCode.vue'
import Leftbar from '../common/LeftBar.vue'
import UserPolicy from './UserPolicy.vue'
import UserCondition from './UserCondition.vue'
import UserSearchSmart from './UserSearchSmart.vue'
import UserSwitch from './UserSwitch.vue'     // 複数ユーザー対応 ユーザー切替え画面

// QuillEditorで使用するcss
import '@vueup/vue-quill/dist/vue-quill.snow.css'

const leftbar = ref()
const rightbar = ref("")


/* メッセージを表示するモーダルウィンドウ */
import MessageModal from '../common/MessageModal.vue'  

let message = ref("")//表示するメッセージ
let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
let message_flag = ref(false)//表示・非表示フラグ
// 複数ユーザー対応 cookieに切り替えたユーザーIDを保存する。
import { useCookies } from 'vue3-cookies'
const { cookies } = useCookies()

let multipleprofile_switch_flg = ref(false)     // ユーザー切替画面を表示するフラグ。
let param_multiple = ref({})    // 切替え候補(家族)を保持する。
let user_id = ref('')   // ユーザー切替画面のパラメータ 現在のユーザーID

/* 表示する子コンポーネント関係の情報 */
const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
contentMessage.value = null // 表示する子コンポーネント

const contentSearchSmart = ref('')// 表示する子コンポーネントの情報（スマホ用検索エリア）
contentSearchSmart.value = null // 表示する子コンポーネント

const contentUserSwitch = ref("")// 表示する子コンポーネントの情報（複数ユーザー対応 ユーザー切替え画面）
contentUserSwitch.value = null// 表示する子コンポーネント

/* ローディングアイコンを表示するモーダルウィンドウ */
import LoadingModal from '../common/LoadingModal.vue'
let loading_flg = ref(false)

import { GlobalData, login_check, logout, set_habitat,DateSetting,DateTimeSetting,ShimekiriSetting,EuDateTimeSetting,EuShimekiriSetting,Kokai_setting,Kaisai_setting,TimeSetting,getUser_email  } from '../js/userdata.js';

import {
    //AmazonCognitoIdentity,
    CognitoUserPool //,
    //CognitoUser,
    //AuthenticationDetails 
} from 'amazon-cognito-identity-js'
import { useRouter, useRoute } from 'vue-router'
import { shallowRef, watch, ref,nextTick } from 'vue'
import axios from 'axios'
import { format } from 'date-fns';
const url = GlobalData.$API_URL
const content = shallowRef('')
const contentLeft = ref('')// 表示する子コンポーネントの情報（左バー）
const contentRight = ref('')// 表示する子コンポーネントの情報（右バー）
const displayStatus = ref(0) //子コンポーネントを再レンダリングさせるためのフラグ
const displayStatus_left = ref(true) //左サイドバーコンポーネントを再レンダリングさせるためのフラグ
const router = useRouter();
const route = useRoute();
const render = ref(0);
const render_Smart = ref(0); // スマホの下部メニューの再描画をするためのカウンター
const comp = ref(); // 左サイドバーから親コンポーネントを通って真ん中コンポーネントに働きかけるための指定
import { string } from 'yup'
import { useStore } from 'vuex'
const store = useStore()
let param = {}
let param_left = {}
let title = "体験プログラム一覧"

let mypage_scroll = 0

// 詳細から一覧へ戻ってきたときのスクロール場所
let list_scrollpos = 0

// ロゴ、タイトルの対応
let header_title1 = "";
let header_title2 = "";

let header_logo = "";
  
let title_style1_pc = ref({"color":"black","font-size": "14px","margin":"15px 0 5px"})
let title_style2_pc = ref({"color":"black","font-size": "15px"})

let title_style1_sp = ref({"color":"black","font-size": "0.65em"})
let title_style2_sp = ref({"color":"black","font-size": "0.95em"})

// キャンセル待ち機能を利用するかどうか（0：利用する、1：利用しない）
let cancel_setting = 1

// URLから閲覧している社協の英名を取得
let cityname = route.params.shakyo

// メール未読が何件あるか
let midoku_count = ref(0)

// 社協英名をstoreに保存
store.state.access_shakyo = cityname
GlobalData.city = cityname

// cognito登録済みでユーザー情報が未登録の場合は１
let not_user_add = 0

// 市区町村コード
let choson_code = ""

// ユーザーが本来所属する社協の名前
let shozoku_name = ref("")

// ユーザーに送られたメール
let mail_rireki_list = {}

// 公開するかどうか（社協が設定した公開日でフラグを立てる）
let kokai_flg = ref()
// 公開前メッセージ
let before_message = ref("")

// 公開終了するかどうか（社協が設定した公開終了日でフラグを立てる。上の公開フラグより優先）
let kokai_end_flg = ref()
// 公開終了後メッセージ
let after_message = ref("")

// チェックイン機能を利用するかどうかのフラグ 1:利用する、2：しない
let checkin_flg = ref(1)

// ユーザー登録後アンケートを実施するかどうか（1なら実施）
let enqete_shubetsu = 1

// 家族の新規登録した時のユーザーID
let new_userid = ''

//---------------------- 体験プログラムレコードを取得する
login_check()

// メールの索引リスト
let mail_list = []

// 分類のリスト
let all_bunrui_list = []
let taiken = []
let shosai = []
let sub = []
let jisseki = []
let jisseki_all = []
let jisseki_all_user = []
let bunrui1 = []
let bunrui2 = []
let select_date = []
let select_date_sub = []
let search_param = {}
//setTimeout(function(){Rightbar_setting()},"1000")

let user_data = [] // ユーザーデータを保存
let Shakyo_data = {}
//let Form_data = {}

let jizen_list = [] // 事前説明会の実績を格納する配列
let jigo_list = [] // 事後集会の実績を格納する配列

let multipleprofile = false  // 複数ユーザー対応  複数ユーザー登録時にTrue
let multiple_new_userid = null

let facility_taiken_id = 0      // 申込完了後の受入先へのメール送信時に使用する体験プログラムID


// 新規登録・プロフィール編集に関する項目
let user_flg = []; // 要不要フラグ
let disp_flg = []; // 表示フラグ
let hissu_flg = []; // 必須フラグ
let user_free_text1 = ""; // フリー項目テキスト1
let user_free_text2 = ""; // フリー項目テキスト2
let user_free_select1 = ""; // フリー項目選択1のタイトル
let user_free_select2 = ""; // フリー項目選択2のタイトル
let user_free_choice1 = ["選択肢が設定されていません。"]; // フリー項目選択1の選択肢
let user_free_choice2 = ["選択肢が設定されていません。"]; // フリー項目選択2の選択肢
let ippan_select = ["選択肢が設定されていません。"]; // 一般区分の選択肢
let pc_age = 18 // 保護者同意年齢
let other_sanka = 1; // 学生以外の参加
let gakusei_kbn_list = [] // 学生区分の利用可不可
let gakusei_meisho_list = [] // 学生区分の名称
let gakusei_sanka = 1 // 学生以外の参加（1:有、2:無）

    //---------------- 社協英名から社協ごとの設定を取得
    let shakyo_read = function(){
        axios.post(url+"Shakyo_read", 
            {shakyo:route.params.shakyo}
            ).then(response => {
            Shakyo_data =  response["data"]
 
            choson_code = response["data"].choson_code

            // ヘッダー関係の取得
            header_logo = response["data"].header_logo
            header_title1 =  response["data"].header_title1
            header_title2 =  response["data"].header_title2
            title_style1_pc.value["color"] = response["data"].header_title_color1
            title_style2_pc.value["color"] = response["data"].header_title_color2
            title_style1_sp.value["color"] = response["data"].header_title_color1
            title_style2_sp.value["color"] = response["data"].header_title_color2

            title_style1_pc.value["font-size"] = response["data"].header_title_size_pc1 + "px"
            title_style2_pc.value["font-size"] = response["data"].header_title_size_pc2 + "px"
            title_style1_sp.value["font-size"] = response["data"].header_title_size_sp1 + "rem"
            title_style2_sp.value["font-size"] = response["data"].header_title_size_sp2 + "rem"

            // ユーザー登録後アンケートの実施有無
            enqete_shubetsu = response["data"].enqete_shubetsu

            // 体験申込までの流れ（フロー）
            // １：体験申込時に事前説明会も申込む
            // ２：事前説明会の参加が確認できないと体験プログラムに申込めない
            GlobalData.$taiken_flow = response["data"].flow

            // 新規登録・プロフィール編集に関する項目
            user_flg = response["data"].user_flg.split(',')
            disp_flg = response["data"].user_disp_flg.split(',')
            hissu_flg = response["data"].user_hissu_flg.split(',')
            user_free_text1 = response["data"].user_free_text1
            user_free_text2 = response["data"].user_free_text2
            user_free_select1 = response["data"].user_free_select1
            user_free_select2 = response["data"].user_free_select2

            // 選択肢はnullの場合もあるので存在確認から行う
            if(response["data"].user_free_choice1){
                user_free_choice1 = response["data"].user_free_choice1.split(/,|、/);
            }
            if(response["data"].user_free_choice2){
                user_free_choice2 = response["data"].user_free_choice2.split(/,|、/);
            }
            if(response["data"].ippan_select){
                ippan_select = response["data"].ippan_select.split(/,|、/);
            }
            pc_age = response["data"].pc_age
            other_sanka = response["data"].sanka

            if(Shakyo_data.kokai_start == "" ){
                Shakyo_data.kokai_start = "00:00:00"
            }

            // 契約終了日の確認
            let today = new Date()
            // 日付が入力されてたらチェック（入力されてなかったら特に何もしない）
            if(Shakyo_data.keiyaku_end_date){
                let keiyaku_end_date = new Date(Shakyo_data.keiyaku_end_date+' 23:59:59')
                console.log(keiyaku_end_date + "←終了日/今日→" + today)
                console.log(keiyaku_end_date <= today)
                if (keiyaku_end_date <= today) {
                    // 今日の日付が終了日以前であれば終了
                    location.href = location.protocol+"//"+location.host+"/"+route.params.shakyo+"/Taiken/End"
                }
            }

            // 公開日時の確認
            if(Shakyo_data.kokai_date){
                let kokai_date = Kokai_setting(Shakyo_data.kokai_date,Shakyo_data.kokai_start)
                if (kokai_date < today) {
                    kokai_flg.value = true;
                } else {
                    kokai_flg.value = false;
                }
            }else{
                kokai_flg.value = true;
            }
            
            // 公開終了日時の確認（未入力の場合はスルー）
            if(Shakyo_data.kokai_end_date){
                let kokai_end_date = Kokai_setting(Shakyo_data.kokai_end_date,Shakyo_data.kokai_end_time)
                if (kokai_end_date > today) {
                    kokai_end_flg.value = true;
                } else {
                    kokai_end_flg.value = false;
                }
            }else{
                 kokai_end_flg.value = true;
            }
            
            // ユーザー登録終了日時を利用する場合（未入力の場合はスルー）
            if(Shakyo_data.user_end_date){
                let end_date = Kokai_setting(Shakyo_data.user_end_date,Shakyo_data.user_end_time)

                // 終了日時が今日より前なら登録不可とする
                if (end_date <= today) {
                    GlobalData.$user_end = 1                    
                }
            }

            console.log(Shakyo_data.kokai_date+"/"+Shakyo_data.kokai_end_date)
            cancel_setting = response["data"].cancel_setting

            // 公開前メッセージ
            before_message.value = "<h3>"+Shakyo_data.shakyo_name +"体験ボランティアは準備中です。<br>公開まで今しばらくお待ちください。</h3>"
            if(response["data"].before_message != "" && response["data"].before_message != null){
                before_message.value = response["data"].before_message.replaceAll("\n","<br>")
            }

            // 公開終了メッセージ
            after_message.value =  "<h3>"+Shakyo_data.shakyo_name +"体験ボランティアは終了いたしました。</h3>"
            if(response["data"].after_message != "" && response["data"].after_message != null){
                after_message.value = response["data"].after_message.replaceAll("\n","<br>")
            }

            // チェックイン機能利用フラグ
            checkin_flg.value = response["data"].checkin_flg

            // 学生区分の取得
            gakusei_kbn_list = response["data"].gakusei_kbn_list.split(",")
            gakusei_meisho_list = response["data"].gakusei_meisho_list.split(",")

            // 学生以外の参加
            gakusei_sanka = response["data"].sanka

            param = { cmd:route.params.cmd, id:route.params.id }
            console.log(param)
            call(param)

            setTimeout(function(){Rightbar_setting()},"1000")
            // メールテンプレートを取得
            setTimeout(function(){mail_read(choson_code)}, "1000");

        })
        .catch(error => {

            console.log(error)
            
        })
    }

    // メールテンプレートを取得する
    let mail_read_error = 0
    let mail_read = function(set_choson_code) { 
        let set_url = url + "Mail_get_list"
        axios.post(set_url,
        {choson_code:set_choson_code,
            kubun:0
        })  //市区町村コードを指定
        .then(response => {
            mail_list = response.data.mail;
            
            console.log("mail_list")
            console.log(mail_list)
        })
        .catch(error => {
            
            if(mail_read_error == 6){
                message.value = error + GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "get_error";
                contentMessage.value = MessageModal
            }else{
                mail_read_error++
                setTimeout(function(){mail_read(set_choson_code)},"1000")
            }
        })
    }

    // フォーム一覧
    let form_get_error = 0
    /*
    let Form_get = function() { 
        let set_url = url + "Form_get"
        axios.post(set_url,
        {
            shakyo:route.params.shakyo,
            syurui:1
        }) 
        .then(response => {
            Form_data = response.data.csv_data;
        })
        .catch(error => {
            
            if(form_get_error == 6){
                message.value = error + GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "get_error";
                contentMessage.value = MessageModal
            }else{
                form_get_error++
                setTimeout(function(){Form_get()},"1000")
            }
        })

    }
    */

  // このユーザーのアンケート・報告書全回答を取得し、アンケートの回答状況をチェックする
    let answer_check_error = 0
    
    let Form_answer_check = function() { 
        
        if(GlobalData.user_id != null){
            let set_url = GlobalData.$API_URL+ "Form_Dynamo_read"
            axios.post(set_url,
            {
                action:"get_form_answers",
                choson_code:route.params.shakyo,
                taikenuser_id:GlobalData.user_id
            }) 
            .then(response => {

            

            // フラグを一度未回答状態にする
            GlobalData.enqete_flg = 0

                for(let i = 0;i<response.data.data.length;i++){
                    let form_data = response.data.data[i]
                    // 種類がアンケート、かつ、フォームNo.が1（ユーザー登録後アンケート）なら回答済みと判断
                    if(form_data.syurui == "enqete" && form_data.form_no == 1){
                        GlobalData.enqete_flg = 1
                    }
                }

            })
            .catch(error => {
                message.value = error + GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "get_error";
                contentMessage.value = MessageModal
            })
        }else{
            // 未ログインなら回答の必要なし
            GlobalData.enqete_flg  = 2
        }
    
    }


    // 祝日を取得
    const calendarId = 'japanese__ja@holiday.calendar.google.com'
    const calendarApiUrl = 'https://www.googleapis.com/calendar/v3/calendars/'
    const apiKey = GlobalData.$holiday_key

    // 祝日を格納する配列
    let holiday_list = []
    
    function loadGoogleCalendarApi() {
        gapi.client.init({
            apiKey: apiKey,
        }).then(() => {
            return gapi.client.request({
            path: calendarApiUrl + encodeURIComponent(calendarId) + '/events'
            })
        }).then((res) => {
            
            const today = new Date()
            let set_date = new Date(today);
            set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
            set_date = new Date(set_date);
            
            // Googleカレンダーで祝日にされてしまっているもの
            let not_holiday = ["雛祭り","クリスマス","母の日","七五三","節分","七夕"]
            const items = res.result.items
            for(let i = 0; i < items.length; i++){
                // 今年と来年の祝日だけ取得
                if(items[i].start.date.substring(0,4) == set_date.getFullYear() ||
                    items[i].start.date.substring(0,4) == (set_date.getFullYear()+1) ){

                        // 祝日ではない場合は挿入しない
                        if(!not_holiday.includes(items[i].summary)){
                            holiday_list[holiday_list.length] = items[i].start.date
                        }

                }
            }
            
        })
    }
    gapi.load('client', loadGoogleCalendarApi)

    //---------------- 種別、分類１・２の設定ファイルを呼び出す
    let category_read_error = 0
    let Category_read = function(cmd){
        let set_url = url + "Taiken_bunrui_read"
        axios.post(set_url,{shakyo:route.params.shakyo}) 
        .then(response => {

            if( response.data.status == 1){
            }else{

                // 分類を格納する
                all_bunrui_list = response.data.csv_data

                if(cmd == "search"){
                    taiken_dsp(cmd)
                }

            }


        })
        .catch(error => {
            
            if(category_read_error == 6){
                message.value = error + GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "get_error";
                contentMessage.value = MessageModal
            }else{
                category_read_error++
                setTimeout(function(){Category_read(cmd)},"1000")
            }
        })

    }

let dsp_count = 0

//---------------- 事前説明会一覧
let jizen_dsp_error = 0
const jizen_dsp = (cmd) => {

    const today = new Date()
    let set_date = new Date(today);
    set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    set_date = new Date(set_date);
            
    let today_set = set_date.getFullYear()+"-"+(set_date.getMonth()+1)+"-"+set_date.getDate()

    console.log(today_set)

    // 今日以前に締め切った事前説明会は除く
    search_param = {"shimekiri_date":today_set}

    if(choson_code != ""){
        search_param.choson_code = choson_code
    }else if(dsp_count < 10){
        dsp_count++
        setTimeout(function(){jizen_dsp(cmd)},"1000")
        return
    }

    axios.post(url+"Jizen_get", search_param)
    .then(response => {
        
        loading_flg.value = false
            render.value = render.value + 1
            title = "事前説明会一覧"
            param = { program:response.data.jizen,cityname:cityname,midoku_count:midoku_count.value,shozoku_name:shozoku_name.value }
            content.value = UserJizenIchiran
            setTimeout(function(){Rightbar_setting()},"1000")

            param_left = {search_param:search_param,
                header_logo:header_logo,
                    header_title1:header_title1,
                    header_title2:header_title2,
                    title_style1:title_style1_pc.value,
                    title_style2:title_style2_pc.value}

            contentLeft.value = Leftbar
    
    })
    .catch(error => {
        if(jizen_dsp_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "get_error";
            contentMessage.value = MessageModal
        }else{
            jizen_dsp_error++
            setTimeout(function(){jizen_dsp(cmd)},"1000")
        }
        
    })
}

let taiken_dsp_error = 0
//---------------- 体験プログラム一覧表示
const taiken_dsp = (cmd) => {

    if(choson_code != ""){
        search_param.choson_code = choson_code
    }else if(dsp_count < 10){
        dsp_count++
        setTimeout(function(){taiken_dsp(cmd)},"1000")
        return
    }

    // 開催日が指定されていた場合、それが祝日かどうか
    let syuku_flg = 0
    if(search_param.kaisai_date != ""){
        for(let i  = 0 ;i<holiday_list.length;i++){
            if(holiday_list[i] == search_param.kaisai_date){
                syuku_flg = 1
            }
        }
    }

    search_param.syuku_flg = syuku_flg

    axios.post(url+"Taiken_get", search_param)
    .then(response => {
        taiken = response.data.taiken
        if(cmd == "search" ){
            
            
            loading_flg.value = false
            render.value = render.value + 1
            title = "体験プログラム一覧"
            param = { 'program':taiken,
                    'nittei':response.data.nittei,
                    'sub':response.data.sub,
                    'sub_nittei':response.data.sub_nittei,
                    'cityname':cityname,
                    'midoku_count':midoku_count.value,
                    'shozoku_name':shozoku_name.value,
                    'holiday_list':holiday_list,
                    'Sankasha':Sankasha,
                    'gakusei_kbn_list':gakusei_kbn_list,
                    'gakusei_meisho_list':gakusei_meisho_list,
                    'gakusei_sanka':gakusei_sanka, }
            content.value = UserPgIchiran

            param_left = {all_bunrui_list:all_bunrui_list,
                search_param:search_param,
                header_logo:header_logo,
                header_title1:header_title1,
                header_title2:header_title2,
                title_style1:title_style1_pc.value,
                title_style2:title_style2_pc.value,
                gakusei_kbn_list:gakusei_kbn_list,
                gakusei_meisho_list:gakusei_meisho_list,
                gakusei_sanka:gakusei_sanka}

            contentLeft.value = UserLeftbar
            // Rightbar_setting()
            Page_scroll_list(list_scrollpos)
            Rightbar_setting()
            // setTimeout(function(){Rightbar_setting()},"1000")
            // setTimeout(function(){Page_scroll_list(list_scrollpos)},"500")
            
        }
    })
    .catch(error => {
        if(taiken_dsp_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "get_error";
            contentMessage.value = MessageModal
        }else{
            taiken_dsp_error++
            setTimeout(function(){taiken_dsp(cmd)},"1000")
        }
        
     //   alert("体験プログラム一覧の取得時にエラーが発生しました。"+error)
    })
}

let buf_desp_count = 0
let buf_read_error = 0
// 詳細に行く前に自分の実績を取得
const taiken_read_buf = (taiken_id,cmd) =>{
    
    if(GlobalData.user_id == null){
        buf_desp_count++
        if(buf_desp_count > 10){
            taiken_read(taiken_id,cmd)
        }else{
            setTimeout(function(){taiken_read_buf(taiken_id,cmd)},"10")
        }
        return
    }
    axios.post(url+"Taikenuser_Jisseki", {taikenuser_id:GlobalData.user_id}, GlobalData.$ID_Token)
    .then(response => {
        console.log("実績読取完了")
        jisseki_buf = response.data.jisseki  // 全実績
        taiken_read(taiken_id,cmd)
    })
    .catch(error => {
        if(buf_read_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "get_error";
            contentMessage.value = MessageModal
        }else{
            buf_read_error++
            setTimeout(function(){taiken_read_buf(taiken_id,cmd)},"1000")
        }
        
    })

}

//---------------- 体験プログラム詳細取得
let taiken_read_error = 0
const taiken_read = (id,cmd,myprogram) => {

    let send_array = {taiken_id:id}
    if(cmd != "myshosai"){
        send_array.choson_code = choson_code
    }
    axios.post(url+"Taiken_read", send_array, GlobalData.$ID_Token)
    .then(response => {

        loading_flg.value = false
        if(cmd == "myshosai"){
            
            param = {
                shosai:response.data,
                jisseki:jisseki_buf,
                program_id:myprogram.program_id,
                sanka:myprogram.sanka,
                houkoku:myprogram.houkoku,
                syomei:myprogram.syomei,
                moshikomi_count:myprogram.moshikomi_count,
                taiken_list:jisseki_prg,
                jizen_list:jizen_list,
                jigo_list:jigo_list,
                cityname:cityname,
                taiken_checkin_count:all_checkin_count,
                Shakyo_data:Shakyo_data,
                mail_list:mail_list} 
            content.value = UserMyShosai
            
            render.value = render.value + 1
            Page_scroll(0)
        }else{
            shosai = response.data
            shosai_user_read(id,cmd)
        }
    })
    .catch(error => {
        if(taiken_read_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "get_error";
            contentMessage.value = MessageModal
        }else{
            taiken_read_error++
            setTimeout(function(){taiken_read(id,cmd,myprogram)},"1000")
        }
        
    })
}


//---------------- 体験プログラム実績取得、ユーザー情報がないなら取得
let user_read_error = 0
const shosai_user_read = (id,cmd) => {

    // 未ログイン状態の場合はそのままjizen_readへ
    if(GlobalData.user_id == null){
        jizen_read(id,cmd)
    }else if(GlobalData.gakusei_kbn == null){
        // 学生区分がnullの場合は取得する
        axios.post(url + "TaikenUser_read",
        {
            taikenuser_id: GlobalData.user_id
        },
        GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
        .then(response => {
            //正常な結果が返ってきた場合の処理
            // response.data["status"]・・・status=0の時は正常終了、status=1のときは異常終了（データが取得できなかった等）
            // response.data["message"]・・・API処理結果に付随するメッセージ。主にstatus=1（異常終了）の時に利用する

            if(response.data["status"] == 1){

                message.value = "ユーザーの取得でエラーが発生しました。\n"+response.data["message"];
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "read_error";
                contentMessage.value = MessageModal
            }else{
                // 職業・学生区分、学年を参加条件として格納
                GlobalData.shokugyo_kbn = response.data.shokugyo_kbn
                GlobalData.gakusei_kbn = response.data.gakusei_kbn
                GlobalData.gakunen = response.data.gakunen

                jizen_read(id,cmd)
            }
        })
        .catch(error => { 
            if(user_read_error == 6){
                message.value = error + GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "get_error";
                contentMessage.value = MessageModal
            }else{
                user_read_error++
                setTimeout(function(){shosai_user_read(id,cmd)},"1000")
            }
        })        
    }else{
        // ログイン状態かつ参加条件も取得済みならそのままjizen_readへ
        jizen_read(id,cmd)
    }
}


//---------------- 全事前説明会取得
let all_jizen_error = 0
const jizen_read = (id,cmd) => {

    if(choson_code != ""){
        search_param.choson_code = choson_code
    }else if(dsp_count < 10){
        dsp_count++
        setTimeout(function(){jizen_read(id,cmd)},"100")
        return
    }

    axios.post(url+"Jizen_get", search_param)
    .then(response => {

        jigo_read(id,cmd,response.data.jizen)

    })
    .catch(error => {
        if(all_jizen_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "get_error";
            contentMessage.value = MessageModal
        }else{
            all_jizen_error++
            setTimeout(function(){jizen_read(id,cmd)},"1000")
        }
    })
}

//---------------- 全事後集会取得
let all_jigo_error = 0
const jigo_read = (id,cmd,jizen) => {

    if(choson_code != ""){
        search_param.choson_code = choson_code
    }else if(dsp_count < 10){
        dsp_count++
        setTimeout(function(){jigo_read(id,cmd,jizen)},"100")
        return
    }

    axios.post(url+"Jigo_get", search_param)
    .then(response => {

        jisseki_read(id,cmd,jizen,response.data.jigo)

    })
    .catch(error => {
        if(all_jigo_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "get_error";
            contentMessage.value = MessageModal
        }else{
            all_jigo_error++
            setTimeout(function(){jigo_read(id,cmd,jizen)},"1000")
        }
        
    })
}

//---------------- 体験プログラム実績取得、詳細画面表示
let jisseki_read_error = 0
const jisseki_read = (id,cmd,jizen,jigo) => {
    axios.post(url+"Taiken_Jissekiread", {taiken_id:id}, GlobalData.$ID_Token)
    .then(response => {
        jisseki = response.data.jisseki
        jisseki_all = response.data.jisseki_all
        jisseki_all_user = response.data.jisseki_all_user
            param = { shosai:shosai,
                jizen:shosai.jizen, 
                jigo:shosai.jigo, 
                jisseki:jisseki,
                jisseki_all:jisseki_all,
                jisseki_all_user:jisseki_all_user,
                myjisseki:jisseki_buf,
                type:cmd,
                cityname:cityname,
                holiday_list:holiday_list ,
                taiken_flow:GlobalData.$taiken_flow,
                        gakusei_kbn_list:gakusei_kbn_list,
                        gakusei_meisho_list:gakusei_meisho_list,
                        gakusei_sanka:gakusei_sanka,
                shozoku_name:shozoku_name.value }
            title = "体験プログラム詳細"
            render.value = render.value + 1
            content.value = UserPgShosai
            setTimeout(function(){Rightbar_setting()},"1000")
            
            param_left = {header_logo:header_logo,
                header_title1:header_title1,
                header_title2:header_title2,
                title_style1:title_style1_pc.value,
                title_style2:title_style2_pc.value,
                moshikomi_ok:0}
            contentLeft.value = UserPgLeftbar

    })
    .catch(error => {
        if(jisseki_read_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "get_error";
            contentMessage.value = MessageModal
        }else{
            jisseki_read_error++
            setTimeout(function(){jisseki_read(id,cmd,jizen,jigo)},"1000")
        }
        
    })
}

//---------------- 体験ユーザーを取得
let only_user_error = 0
const user_read = function(cmd){
    if(GlobalData.user_id == null){
        router.push("/"+cityname+"/Taiken/mypage")
        return
    }

	axios.post(url + "TaikenUser_read",
	{
        taikenuser_id: GlobalData.user_id
	},
    GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
	.then(response => {
		//正常な結果が返ってきた場合の処理
		// response.data["status"]・・・status=0の時は正常終了、status=1のときは異常終了（データが取得できなかった等）
		// response.data["message"]・・・API処理結果に付随するメッセージ。主にstatus=1（異常終了）の時に利用する

		if(response.data["status"] == 1){

            message.value = "ユーザーの取得でエラーが発生しました。\n"+response.data["message"];
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "read_error";
            contentMessage.value = MessageModal
		}else{

            user_data = response.data;
            if(cmd == "profile"){
                content.value = UserToroku
                param_left = {header_logo:header_logo,
                header_title1:header_title1,
                header_title2:header_title2,
                title_style1:title_style1_pc.value,
                title_style2:title_style2_pc.value}
                contentLeft.value = UserMyLeftbar

                param = {user:response.data,
                        type:"henshu",
                        cityname:cityname,
                        user_flg:user_flg,
                        disp_flg:disp_flg,
                        hissu_flg:hissu_flg,
                        user_free_text1:user_free_text1,
                        user_free_text2:user_free_text2,
                        user_free_select1:user_free_select1,
                        user_free_select2:user_free_select2,
                        user_free_choice1:user_free_choice1,
                        user_free_choice2:user_free_choice2,
                        ippan_select:ippan_select,
                        pc_age:pc_age,
                        other_sanka:other_sanka,
                        gakusei_kbn_list:gakusei_kbn_list,
                        gakusei_meisho_list:gakusei_meisho_list,
                        gakusei_sanka:gakusei_sanka,
                        multipleprofile:!user_data.role   // 家族登録フラグ(True:家族などのログインできないユーザー False:ログインユーザー)
                     }

                title = "プロフィール編集"
            }
        }
	})
	.catch(error => { 
        if(only_user_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "get_error";
            contentMessage.value = MessageModal
        }else{
            only_user_error++
            setTimeout(function(){user_read(cmd)},"1000")
        }
    })
 }


//---------------- 体験ユーザーの事前説明会・事後集会の実績取得
let user_jisseki_error = 0
const user_jisseki_read = function(){
     axios.post(url + "Taikenuser_Program",
     {
         taikenuser_id: GlobalData.user_id,
         cancel:1
     },
     GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
     .then(response => {
         if(response.data["status"] == 1){
             message.value = "体験ユーザーの事前説明会・事後集会実績取得でエラーが発生しました。\n"+response.data["message"];
             message_cat.value = 0;
             message_flag.value = true;
             message_method.value = "read_error";
             contentMessage.value = MessageModal
         }else{
            
            let moushikomi_flg = true
            // 種別が制作・寄付活動の時
            if(shosai.shubetsu == 2){
                 // jisseki[0] = {"teiin":60}// 満員デバッグ用
                // 実績データが一件でも存在する場合は定員チェック
                if(jisseki.length != 0){

                    if(jisseki[0]["teiin"] >= shosai.seisaku_teiin){
                        moushikomi_flg = false
                        
                    }else{
                        moushikomi_flg = true
                    }
                }else{
                    moushikomi_flg = true
                }
            }
            console.log(GlobalData.user_id)
            param = {sanka:select_date,
                    sanka_sub:select_date_sub,
                    taiken:shosai,
                    sub:sub,
                    jizen:shosai.jizen,
                    jigo:shosai.jigo,
                    user_id:GlobalData.user_id,
                    set_jizen:response["data"].jizen,
                    set_jigo:response["data"].jigo,
                    moshikomi:moushikomi_flg ,
                    cityname:cityname }
            title = "参加申込み"
            content.value = UserPgMoshikomi
            
            param_left = {header_logo:header_logo,
                header_title1:header_title1,
                header_title2:header_title2,
                title_style1:title_style1_pc.value,
                title_style2:title_style2_pc.value}
            contentLeft.value = Leftbar
            Page_scroll(0)
         }
     })
     .catch(error => {  
        if(user_jisseki_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "get_error";
            contentMessage.value = MessageModal
        }else{
            user_jisseki_error++
            setTimeout(function(){user_jisseki_read()},"1000")
        }
        
     })
 
 }

 let new_jizen_jisseki = []
//--------------- 事前説明会参加登録処理（事前説明会のみを申込む）
let jizen_jisseki_add_error = 0
 let Jizen_jisseki_add = function(moshikomi_pg,user_id,cancel_jizen_id){

  // セットする事前説明会
  new_jizen_jisseki = []
  new_jizen_jisseki[0] = {"jizen_id":moshikomi_pg.jizen_id,
                        "kaisai_date":moshikomi_pg.kensyu_date,
                        "jikantai_start":moshikomi_pg.jikantai_start,
                        "jikantai_end":moshikomi_pg.jikantai_end,
                        "jizen_name":moshikomi_pg.jizen_name,
                        "bikou1":moshikomi_pg.bikou1,
                        "basyo":moshikomi_pg.basyo}


  let jizen_jisseki = {"taikenuser_id":user_id,"jizen":new_jizen_jisseki}
    loading_flg.value = true
    axios.post(url + "Jisseki_add",
    jizen_jisseki,
    GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
    .then(response => {
        //正常な結果が返ってきた場合の処理
        // response.data["status"]・・・status=0の時は正常終了、status=1のときは異常終了（データが取得できなかった等）
        // response.data["message"]・・・API処理結果に付随するメッセージ。主にstatus=1（異常終了）の時に利用する

        loading_flg.value = false
        if(response.data["status"] == 1){
            alert(response.data["message"])
        }else if(response.data["status"] == 2){
            // 定員オーバー
            message.value = response.data["message"];
            message_method.value = "add_error";
            message_cat.value = 0;
            message_flag.value = true;
            contentMessage.value = MessageModal
        }else{

            // 履歴登録
            const today = new Date()
            let set_date = new Date(today);
            set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
            set_date = new Date(set_date);
            rireki_kanri_add(set_date,1,user_id,2,moshikomi_pg.jizen_id,0,0)

            new_jizen_jisseki.moshikomi_date = response.data["moshikomi_date"]
            message.value = "申込みが完了しました。";
            message_method.value = "jizen_jisseki_add";
            message_cat.value = 0;
            message_flag.value = true;
            contentMessage.value = MessageModal
           
        }
        
    })
    .catch(error => {   
        if(jizen_jisseki_add_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "get_error";
            contentMessage.value = MessageModal
        }else{
            jizen_jisseki_add_error++
            setTimeout(function(){Jizen_jisseki_add(moshikomi_pg,user_id,cancel_jizen_id)},"1000")
        }
        
    })
 }
 
// 事前説明会をキャンセルする（体験フローパターン1でキャンセルの必要がある場合の対応）
let jizen_cancel_1_error = 0
let Jizen_cancel_1 = function(moshikomi_pg,user_id,cancel_jizen_id){
    let send_array = {
        user_id: user_id,
        program_id:cancel_jizen_id,
        program_kbn:2,
        jokyo:9,
        update_user:getUser_email()//更新者（＝ログインユーザーのメールアドレス）
    }
    axios.post(url + "Jisseki_Programupdate",send_array,GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
    .then(response => {
        if(response.data["status"] == 1){
            alert("事前説明会の更新エラー\n"+response.data["message"])
        }else{
            Jizen_jisseki_add(moshikomi_pg,user_id,cancel_jizen_id)
        }
    })
    .catch(error => {  
        if(jizen_cancel_1_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "get_error";
            contentMessage.value = MessageModal
        }else{
            jizen_cancel_1_error++
            setTimeout(function(){Jizen_cancel_1(moshikomi_pg,user_id,cancel_jizen_id)},"1000")
        }
        
    })
}
 
//--------------- 参加登録処理：体験プログラム（必要な場合は事前説明会・事後集会を共に）登録する
let new_jisseki = []
let jisseki_add_error = 0
let Jisseki_add = function(jisseki,jizen_set_flg,user_id,cancel_jizen_id,message_title,message_honbun,taiken_name,user_name,jizen_moushikomi_list) {
    loading_flg.value = true
    
    // キャンセル待ち機能を利用するかどうかのフラグ追加
    jisseki.cancel_setting = cancel_setting

    // 総申込者を利用するかどうかのフラグと、総申込者数自体を追加
    jisseki.all_moshikomi_flg = Shakyo_data.all_moshikomi_flg
    jisseki.all_moshikomi_count = Shakyo_data.all_moshikomi_count

    // 市区町村コード追加
    jisseki.choson_code = route.params.shakyo


    axios.post(url + "Jisseki_add",
    jisseki,
    GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
    .then(response => {
        //正常な結果が返ってきた場合の処理
        // response.data["status"]・・・status=0の時は正常終了、status=1のときは異常終了（データが取得できなかった等）
        // response.data["message"]・・・API処理結果に付随するメッセージ。主にstatus=1（異常終了）の時に利用する

        loading_flg.value = false
        if(response.data["status"] == 1){
            alert("実績の追加でエラーが発生しました。\n"+response.data["message"])
        }else if(response.data["status"] == 2){
            // 定員オーバー
             message.value = response.data["message"];
             message_cat.value = 0;
             message_flag.value = true;
             message_method.value = "Jisseki_add_error";
             contentMessage.value = MessageModal
        }else{
            
            // メッセージが入力されている場合はメッセージ登録へ
            if(message_honbun != "" && message_honbun != null){
              message_add(message_title,message_honbun,jisseki.taiken_id,response.data["moshikomi_count"],taiken_name,user_name)
            }

            // 新規追加した実績データを格納
            new_jisseki = jisseki
            new_jisseki.moshikomi_date = response.data["moshikomi_date"]
            
            // 申し込む事前説明会を追加
            jisseki.jizen_moushikomi_list = jizen_moushikomi_list

            // 履歴登録
            const today = new Date()
            let set_date = new Date(today);
            set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
            set_date = new Date(set_date);
            rireki_kanri_add(set_date,1,user_id,1,jisseki.taiken_id,0,response.data["moshikomi_count"])

            // 事前説明会をキャンセルする場合は先に処理
            if(jizen_set_flg == 1){
                Jizen_cancel(user_id,cancel_jizen_id)
            }else{
                // 必要がない場合はメールを送信
                mail_create()
                // 受入先へメールを送信する。
                facility_mail_send()
            }
            
        }
    })
    .catch(error => {  
        if(jisseki_add_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "get_error";
            contentMessage.value = MessageModal
        }else{
            jisseki_add_error++
            setTimeout(function(){Jisseki_add(jisseki,jizen_set_flg,user_id,cancel_jizen_id,message_title,message_honbun,jizen_moushikomi_list)},"1000")
        }
        
    })
}

// 登録時、メッセージのデータを追加する
let message_add_error = 0
const message_add = (message_title,message_honbun,taiken_id,moshikomi_count,taiken_name,user_name) =>{
  axios.post(url +"Message_add",
        {
          shakyo_name:choson_code,
          choson_code:choson_code,
          taikenuser_id:GlobalData.user_id,
          program_id:taiken_id,
          message_title:message_title,
          message_honbun:message_honbun,

        },
        GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
        .then(response => {
            if(response.data["status"] == 1){  // 異常終了時の処理
              message.value = "メッセージの送信に失敗しました。再送する場合は「マイページ」から送信してください。";
              message_method.value = "message_error";
              message_cat.value = 0;
              message_flag.value = true;
              contentMessage.value = MessageModal
                
            }else{// 正常終了時の処理

              // 履歴を追加
              message_rireki_add(8,taiken_id,GlobalData.user_id,message_title,message_honbun,taiken_name,user_name)
            }
        })
        .catch(error => {
            if(message_add_error == 6){
                message.value = error + GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "message_error";
                contentMessage.value = MessageModal
            }else{
                message_add_error++
                setTimeout(function(){
                  message_add(message_title,message_honbun,taiken_id)
                },"1000")
            }
      })
}

// メッセージの履歴登録
let message_rireki_add_error = 0
let message_rireki_add = function(kubun,taiken_id,taikenuser_id,message_title,message_honbun,taiken_name,user_name){
    const today = new Date()
    let set_date = new Date(today);
    set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    set_date = new Date(set_date);
    let send_data = {shakyo_name:route.params.shakyo,
        choson_code:choson_code,
        taikenuser_id:GlobalData.user_id,
        program_kbn:1,
        program_id:taiken_id,
        kubun:kubun,
        toroku_date:set_date,
        update_user:GlobalData.$User_email}

        // APIへ値を送信する
        axios.post(url+"Rireki_add",
        send_data,
        GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
        .then(response => {

            if(response.data["status"] == 1){

                message.value = error + GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "rireki_add_error";
                contentMessage.value = MessageModal
            } else {
                if(message_honbun != '' && message_honbun != null) {
                // メッセージを社協の管理宛にメールを送信する
                shakyo_mail_send(taiken_id,taikenuser_id,message_title,message_honbun,taiken_name,user_name)
                }
            }
            
        })
        .catch(error => {
            if(message_rireki_add_error == 6){
                message.value = error + GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "message_error";
                contentMessage.value = MessageModal
            }else{
                rireki_add_error++
                setTimeout(function(){
                  message_rireki_add(kubun,taiken_id,taikenuser_id,message_title,message_honbun)
                },"1000")
            }
      })
}

// メッセージを社協の管理宛にメールを送信する
let shakyo_mail_send_error = 0
let shakyo_mail_send = function(taiken_id,taikenuser_id,message_title,message_honbun,taiken_name,user_name){
    axios.post(GlobalData.$API_URL+"Shakyo_read", 
        {shakyo:route.params.shakyo}
        ).then(response => {

        if(response.data["status"] == 0){
          if(response["data"].shakyo_email != undefined && response["data"].shakyo_email != null )
            shakyo_mailsend(response["data"].shakyo_email,taiken_id,taikenuser_id,message_title,message_honbun,taiken_name,user_name)
          else{
            alert("社協のメールが登録されていません。")
          }
        }else{
          alert("エラーが発生しました。\n"+response.data["message"])
        }        
    })
    .catch(error => {
          if(shakyo_mail_send_error == 6){
              message.value = error + GlobalData.$axios_error
              message_cat.value = 1;
              message_flag.value = true;
              message_method.value = "shakyo_mail_send_error";
              contentMessage.value = MessageModal
          }else{
              shakyo_mail_send_error++
              setTimeout(function(){shakyo_mail_send(taiken_id,taikenuser_id,message_title,message_honbun,taiken_name,user_name)},"1000")
          } 
        
    })
}

// 体験プログラム申込みからのメッセージを社協のメールに送信する
let shakyo_mailsend_error = 0
let shakyo_mailsend = function(email,taiken_id,taikenuser_id,message_title,message_honbun,taiken_name,user_name){
  let title = ''
  let honbun = ''
  if(message_title == '' || message_title == null){
    title = 'ボラ活エール【体験】  申込者からメッセージが届いています。'
  } else {
    title = message_title
  }

  honbun = '送信日時：' + format(new Date(), 'yyyy年MM月dd日 HH:mm:ss') + '\n'
  honbun += 'メッセージ送信者：' + user_name + '\n' 
  honbun += '対象プログラム：' + taiken_name + '\n'
  honbun += '---------------------------------------------------------' + '\n'
  honbun += message_honbun

  let send_data = {email:email,title:title,text:honbun,reply_to:Shakyo_data.shakyo_email}

    // APIへ値を送信する
    axios.post(GlobalData.$API_URL+"Mail_send",
    send_data,
    GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
    .then(response => {

    })
    .catch(error => {
        if(shakyo_mailsend_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "check_error";
            contentMessage.value = MessageModal
        }else{
            shakyo_mailsend_error++
            setTimeout(function(){shakyo_mailsend(email,taiken_id,taikenuser_id,message_title,message_honbun,taiken_name,user_name)},"1000")
        }
    })
}

// 事前説明会をキャンセルする（体験フローパターン2でキャンセルの必要がある場合の対応）
let jizen_cancel_error = 0
let Jizen_cancel = function(user_id,cancel_jizen_id){
    let send_array = {
        user_id: user_id,
        program_id:cancel_jizen_id,
        program_kbn:2,
        jokyo:9,
        update_user:getUser_email()//更新者（＝ログインユーザーのメールアドレス）
    }
    axios.post(url + "Jisseki_Programupdate",send_array,GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
    .then(response => {
    if(response.data["status"] == 1){
        
    }else{
        // メールを送信
        mail_create()
    }
    })
    .catch(error => { 
        if(jizen_cancel_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "get_error";
            contentMessage.value = MessageModal
        }else{
            jizen_cancel_error++
            setTimeout(function(){Jizen_cancel(user_id,cancel_jizen_id)},"1000")
        } 
        
    })
}

//---------------- 申込み完了メールを送信するためのユーザー情報を取得する
let mail_create_error = 0
const mail_create = () => {
    
    // まずはユーザー情報を取得
	axios.post(url + "TaikenUser_read",
	{
        taikenuser_id: GlobalData.user_id,
        choson_code:choson_code
	},
    GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
	.then(response => {
		//正常な結果が返ってきた場合の処理
		// response.data["status"]・・・status=0の時は正常終了、status=1のときは異常終了（データが取得できなかった等）
		// response.data["message"]・・・API処理結果に付随するメッセージ。主にstatus=1（異常終了）の時に利用する

		if(response.data["status"] == 1){

            message.value = GlobalData.$axios_error
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "read_error";
            contentMessage.value = MessageModal
		}else{
            // 職業・学生区分を参加条件として格納
            GlobalData.shokugyo_kbn = response.data.shokugyo_kbn
            GlobalData.gakusei_kbn = response.data.gakusei_kbn
            new_jisseki.user = response.data
            mail_taiken_read()
        }
	})
	.catch(error => { 
        if(mail_create_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "get_error";
            contentMessage.value = MessageModal
        }else{
            mail_create_error++
            setTimeout(function(){mail_create()},"1000")
        } 
    })

}

//---------------- 体験プログラム詳細取得
let mail_taiken_read_error = 0
let mail_taiken_read = () => {
    axios.post(url+"Taiken_read", {taiken_id:new_jisseki.taiken_id,choson_code:choson_code}, GlobalData.$ID_Token)
    .then(response => {
        new_jisseki.taiken_data = response.data
        mail_jizen_read()
    })
    .catch(error => {
        if(mail_taiken_read_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "get_error";
            contentMessage.value = MessageModal
        }else{
            mail_taiken_read_error++
            setTimeout(function(){mail_taiken_read()},"1000")
        } 
        
    })
}
//---------------- 事前説明会詳細取得
let mail_jizen_read_error = 0
let mail_jizen_read = () => {
    let set_jizen_id = 0

    if(new_jisseki.jizen_id != 0){
        set_jizen_id = new_jisseki.jizen_id
    }else{
        if(new_jisseki.jizen_moushikomi_list[0]){
            if(new_jisseki.jizen_moushikomi_list[0].jizen_id){
                set_jizen_id = new_jisseki.jizen_moushikomi_list[0].jizen_id
            }
        }
    }
    axios.post(url+"Jizen_read", {jizen_id:set_jizen_id,choson_code:choson_code}, GlobalData.$ID_Token)
    .then(response => {
        new_jisseki.jizen_data = response.data
        mail_jigo_read()
    })
    .catch(error => {
        if(mail_jizen_read_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "get_error";
            contentMessage.value = MessageModal
        }else{
            mail_jizen_read_error++
            setTimeout(function(){mail_jizen_read()},"1000")
        } 
        
    })
}

//---------------- 事後集会詳細取得
let mail_jigo_read_error = 0
let mail_jigo_read = () => {
    axios.post(url+"Jigo_read", {jigo_id:new_jisseki.jigo_id,choson_code:choson_code}, GlobalData.$ID_Token)
    .then(response => {
            
        new_jisseki.jigo_data = response.data
        loading_flg.value = false
        message.value = "申込みが完了しました。";
        message_cat.value = 0;
        message_flag.value = true;
        message_method.value = "jisseki_add";
        contentMessage.value = MessageModal

        
    })
    .catch(error => {
        if(mail_jigo_read_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "get_error";
            contentMessage.value = MessageModal
        }else{
            mail_jigo_read_error++
            setTimeout(function(){mail_jigo_read()},"1000")
        } 
    })
}


// 申込み完了メールを作成する（プログラム）
let moshikomi_cancel_wait = 0 // キャンセル待ち申込がある場合は１
let mail_moshikomi_create = function(){

    let set_date = ShimekiriSetting(new_jisseki.moshikomi_date);

    // 利用するメールテンプレートを指定
    let set_mail = mail_list[2]

    // キャンセル待ち申込の場合はテンプレート変更
    if(moshikomi_cancel_wait == 1){
        set_mail = mail_list[11]
    }

    // 曜日配列
    const youbi_list = ["日","月","火","水","木","金","土"]
    let moshikomi = (set_date.getMonth()+1)+"月"+set_date.getDate()+"日（"+youbi_list[set_date.getDay()]+"）"+ ('00'+set_date.getHours()).slice(-2)+":"+('00'+set_date.getMinutes()).slice(-2)
    let mypage_url = location.protocol+"//"+location.host+"/"+cityname+"/Taiken/mypage"

    // メール実施フラグが立ってたらメールを送る
    if(set_mail.jisshi == true){

        // メールの内容を作成
        let set_title = set_mail.title
        let set_text = ""
        if(set_mail.naiyou != "" && set_mail.naiyou != null){
            set_text = set_mail.naiyou.replace(/<br>/g, '\n')
        }

            
        // 各項目を変換

        // 申込者名
        set_text = set_text.replace(/<申込者名>/g, new_jisseki.user.username)

        // 申込日時
        set_text = set_text.replace(/<申込日時>/g, moshikomi)

        // 体験プログラム・内容
        let set_naiyo = "名称："+new_jisseki.taiken_data.name+"\n"
        set_naiyo += "場所："+new_jisseki.taiken_data.k_jusyo+"\n"
        set_naiyo += "内容："+new_jisseki.taiken_data.naiyou

        set_text = set_text.replace(/<体験プログラム・内容>/g, set_naiyo)

        // 体験プログラム・日程
        let set_nittei = ""   
        if(new_jisseki.taiken.length != 0){
            let taiken_array = new_jisseki.taiken
            console.log(taiken_array)

            for(let t = 0;t<taiken_array.length;t++){
                if(t!=0) set_nittei += "\n"
                set_nittei += "（"+(t+1)+"）"+DateSetting(taiken_array[t].kaisai_date)+" "
                +TimeSetting(taiken_array[t].jikantai_start) +"～"
                +TimeSetting(taiken_array[t].jikantai_end)

                if(moshikomi_cancel_wait == 1){
                    if(taiken_array[t].ninzu >= taiken_array[t].teiin){
                        set_nittei += " キャンセル待ち（"+parseInt((taiken_array[t].ninzu - taiken_array[t].teiin)+1)+"番目）"
                    }
                }
            }
        }

        set_text = set_text.replace(/<体験プログラム・日程>/g, set_nittei)

        // 体験プログラム・事前説明会
        let set_jizen = ""

        console.log(new_jisseki.jizen_data)
        
        // ここでうまく拾えてない可能性あり
        if(new_jisseki.jizen_data.kensyu_date != undefined){
            set_jizen += "名称："+new_jisseki.jizen_data.jizen_name+" "

            if(new_jisseki.jizen_data.syurui == 3){
                set_jizen +="\n期間："
                if(new_jisseki.jizen_data.movie_start_date){
                    set_jizen += DateSetting(new_jisseki.jizen_data.movie_start_date)+"～"
                }

            }else{
                set_jizen +="\n日時："

            }
            if(new_jisseki.jizen_data.kensyu_date){
                set_jizen += DateSetting(new_jisseki.jizen_data.kensyu_date)
            }
            
            if(new_jisseki.jizen_data.jikantai_start){
                set_jizen += TimeSetting(new_jisseki.jizen_data.jikantai_start) +"～"
            }

            if(new_jisseki.jizen_data.jikantai_end){
                set_jizen += TimeSetting(new_jisseki.jizen_data.jikantai_end)
            }

            if(new_jisseki.jizen_data.basyo) set_jizen += "\n場所："+new_jisseki.jizen_data.basyo
        }
            
        set_text = set_text.replace(/<事前説明会>/g, set_jizen)

        // 体験プログラム・事後集会
        let set_jigo = ""
        if(new_jisseki.jigo_data.kaisai_date != undefined){
            set_jigo +="日時："+ DateSetting(new_jisseki.jigo_data.kaisai_date)+" "
                    +TimeSetting(new_jisseki.jigo_data.jikantai_start) +"～"
                    +TimeSetting(new_jisseki.jigo_data.jikantai_end)
            if(new_jisseki.jigo_data.basyo) set_jigo += "\n場所："+new_jisseki.jigo_data.basyo
        }
        set_text = set_text.replace(/<事後集会>/g, set_jigo)


        set_text = set_text.replace(/<マイページURL>/g, mypage_url)

        // 重要フラグを付けて送信APIへ
        mail_send(set_title,set_text,"moshikomi",set_mail.critical)
    }else{
        //メール送信の必要がない場合は送らずにマイページへ
        router.push("/"+cityname+"/Taiken/mypage")
    }
}

// 申込み完了メールを作成する
let mail_jizen_create = function(){

    let set_date = ShimekiriSetting(new_jizen_jisseki[0].moshikomi_date);

    // 曜日配列
    const youbi_list = ["日","月","火","水","木","金","土"]
    let moshikomi = (set_date.getMonth()+1)+"月"+set_date.getDate()+"日（"+youbi_list[set_date.getDay()]+"）"+ ('00'+set_date.getHours()).slice(-2)+":"+('00'+set_date.getMinutes()).slice(-2)
    let mypage_url = location.protocol+"//"+location.host+"/"+cityname+"/Taiken/mypage"

    // メール実施フラグが立ってたらメールを送る
    if(mail_list[7].jisshi == true){

        // メールの内容を作成
        let set_title = mail_list[7].title
        let set_text = ""
        if(mail_list[7].naiyou != "" && mail_list[7].naiyou != null){
            set_text = mail_list[7].naiyou.replace(/<br>/g, '\n')
        }
            
        // 各項目を変換

        // 申込者名
        set_text = set_text.replace(/<申込者名>/g, GlobalData.user_name)

        // 申込日時
        set_text = set_text.replace(/<申込日時>/g, moshikomi)

        // 事前説明会
        let set_jizen = ""
        console.log(new_jizen_jisseki)
        if(new_jizen_jisseki[0].kaisai_date != undefined){
            
            set_jizen += "名称："+new_jizen_jisseki[0].jizen_name
            set_jizen +="\n開催日時："+ DateSetting(new_jizen_jisseki[0].kaisai_date)
            
            if(new_jizen_jisseki[0].jikantai_start){
                set_jizen += TimeSetting(new_jizen_jisseki[0].jikantai_start) + "～" +TimeSetting(new_jizen_jisseki[0].jikantai_end)
            } 
            
            if(new_jizen_jisseki[0].basyo) set_jizen += "\n場所："+new_jizen_jisseki[0].basyo
            
            if(new_jizen_jisseki[0].bikou1) set_jizen += "\n特記事項："+new_jizen_jisseki[0].bikou1

            /*
            
  new_jizen_jisseki[0] = {"jizen_id":moshikomi_pg.jizen_id,
                        "kaisai_date":moshikomi_pg.kensyu_date,
                        "jikantai_start":moshikomi_pg.jikantai_start,
                        "jikantai_end":moshikomi_pg.jikantai_end,
                        "jizen_name":moshikomi_pg.jizen_name,
                        "bikou1":moshikomi_pg.bikou1,
                        "basyo":moshikomi_pg.basyo}
            */
        }
        set_text = set_text.replace(/<事前説明会>/g, set_jizen)
        set_text = set_text.replace(/<マイページURL>/g, mypage_url)

        // 重要フラグを付けて送信APIへ
        mail_send(set_title,set_text,"jizen_moshikomi",mail_list[7].critical)
    }else{
        //メール送信の必要がない場合は送らずにマイページへ
        router.push("/"+cityname+"/Taiken/mypage")
    }
}

//---------------------- マイページを表示する
let jisseki_prg = []  // 一意な体験プログラムのテーブル
let jisseki_buf = []  // キャンセルのレコードを除くためのバッファ
let all_checkin_count = 0 // チェックイン済みの実績をカウント
let error_count = 0 // 規定数以上エラー起こしたらエラーメッセージを表示
const my_jisseki = () => {
    // ログインチェック

    console.log(GlobalData.$User_email)

    if (GlobalData.$User_email) {                    // ログインしているかチェック
        if (GlobalData.user_id) {              // ユーザー情報があるかチェック
            rightbar.value.login_mode
        } else {
            loading_flg.value = false
            // GlobalData.user_id がない（ユーザー情報が登録されていない）場合は登録画面へ移動する
            message.value = "システムの利用には、ユーザー情報（プロフィール）の登録が必要です。<br><b style='color:red'>ユーザー情報は必ず体験者本人の情報を入力してください。</b>";
            message_cat.value = 2;
            message_flag.value = true;
            message_method.value = "user_error";
            contentMessage.value = MessageModal
            return
        }
    } else {
        // ログインしてない場合はログイン画面へ
        loading_flg.value = false
        param = { cmd:"login"}
        call(param)
        return
    }

    if(GlobalData.kengen == "admin" ){
        location.href=location.protocol+'//'+location.host+"/"+cityname+"/Taiken/mypage"
        return
    }

    jisseki_prg.length = 0
    let id = GlobalData.user_id

    axios.post(url+"Taikenuser_Jisseki", {taikenuser_id:id}, GlobalData.$ID_Token)
    .then(response => {

        jisseki_buf = response.data.jisseki  // 全実績
        jisseki_prg = response.data.taiken_list // プログラムごとの実績（体験）
        all_checkin_count = response.data.taiken_count // プログラムごとのチェックイン数（体験）
        jizen_list = response.data.jizen_list // プログラムごとの実績（事前説明会）
        jigo_list = response.data.jigo_list // プログラムごとの実績（事後集会）
        
        setTimeout(rightbar.value.login_mode, "10");
        loading_flg.value = false
        param = { program:jisseki_prg,jizen:jizen_list ,jigo:jigo_list ,cityname:cityname ,taiken_checkin_count:all_checkin_count,Shakyo_data:Shakyo_data,midoku_count:midoku_count.value,jisseki_buf:jisseki_buf}
        title = "マイページ"
        content.value = UserMypage

        Page_scroll_list(mypage_scroll);
        
        param_left = {header_logo:header_logo,
                header_title1:header_title1,
                header_title2:header_title2,
                title_style1:title_style1_pc.value,
                title_style2:title_style2_pc.value}
        contentLeft.value = UserMyLeftbar
        
        render.value = render.value + 1
       // my_jizen(all_checkin_count)    // 続いて事前説明会の実績レコードを読み込む
        Rightbar_setting()
        //setTimeout(function(){Rightbar_setting()},"1000")
    })
    .catch(error => {
        
        if(error_count == 6){
            loading_flg.value = false
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "get_error";
            contentMessage.value = MessageModal
        }else{
            error_count++
            setTimeout(function(){my_jisseki()},"1000")
        }
    })
}

/* その他の関数の記述 */
// 指定した高さになるまで待つ
const waitForScrollableHeight = (el, targetTop, maxWait = 3000) => {
  return new Promise((resolve) => {
    const start = performance.now()

    const check = () => {
      const scrollEl = el || document.documentElement
      const currentMaxScroll = scrollEl.scrollHeight - scrollEl.clientHeight

      // 目的位置までスクロールできる高さが確保できたら完了
      if (currentMaxScroll >= targetTop) {
        resolve(true)
        return
      }

      // タイムアウト
      if (performance.now() - start > maxWait) {
        resolve(false)
        return
      }

      requestAnimationFrame(check)
    }

    check()
  })
}

// ページの一番上にスクロールする：height＝位置（上から何pxか）
const Page_scroll_list = async (height) => {
    if (height == 0){
        // !heightは0の時も弾いてしまうので、0は例外的に通す。
    }else if (!height) {
        return
    }
    console.log(height)

  await nextTick()

  const isSP = window.matchMedia("(max-width: 960px)").matches

  if (isSP) {
    await waitForScrollableHeight(document.documentElement, height)
    window.scrollTo({
      top: height,
      left: 0,
      behavior: "auto"
    })
  } else {
    const el = document.querySelector("#vy_main")
    if (!el) return

    await waitForScrollableHeight(el, height)
    el.scrollTo({
      top: height,
      behavior: "auto"
    })
  }
}

//----------------------- 事前説明会の実績レコードを読み込む

// taiken_checkin_count：体験プログラムのチェックイン数
const my_jizen = (taiken_checkin_count) => {
    let id = GlobalData.user_id
    axios.post(url+"Taikenuser_Jisseki", {taikenuser_id:id, program_kbn:2}, GlobalData.$ID_Token)
    .then(response => {
        let jisseki_jizen = response.data.jisseki  // 自分の実績レコード（事前説明会）を取得する
        // 事前説明会実績レコードをprogram_idでソートし、重複を無くす
        jisseki_jizen.sort(function(a,b) {
            if (a.program_id >= b.program_id) {
                return 1
            } else {
                return -1
            }
        })
        // 実績テーブルに追加する
        let pid = -1
        jizen_list = []
        for (let i=0;i<jisseki_jizen.length;i++) {
            if(jisseki_jizen[i].jokyo != 9){
                if (jisseki_jizen[i].program_id != pid ) {
                    jizen_list[jizen_list.length] = jisseki_jizen[i]
                    pid = jisseki_jizen[i].program_id
                }
            }
        }

        setTimeout(rightbar.value.login_mode, "10");
        loading_flg.value = false
        param = { program:jisseki_prg,jizen:jizen_list ,cityname:cityname ,taiken_checkin_count:taiken_checkin_count,Shakyo_data:Shakyo_data,midoku_count:midoku_count.value}
        title = "マイページ"
        content.value = UserMypage
        param_left = {header_logo:header_logo,
                header_title1:header_title1,
                header_title2:header_title2,
                title_style1:title_style1_pc.value,
                title_style2:title_style2_pc.value}
        contentLeft.value = UserMyLeftbar
    })
    .catch(error => {
        
    })
}

  // ユーザー削除前にログアウト 
  const User_Delete_logout = async () => {
      
      try {
        await axios.post("/dev/logout_lambda", {}, { withCredentials: true });
        // ユーザー削除へ
        User_Delete()
    
      } catch (err) {
          console.error(err);
        //  alert("ログアウト失敗");
      } finally {
        // ログアウト時は、cookieの情報をクリアする。
        if(cookies.isKey('switch_user')){
            cookies.remove('switch_user')
        }
        if(cookies.isKey('family')){
            cookies.remove('family')
        }
      }
  };  

// ユーザーを削除する
let user_delete_error = 0
let User_Delete = function(){
        
  axios.post(url + "TaikenUser_delete",
  {
    // 送信する値は「変数名:変数名」
    taikenuser_id: GlobalData.user_id,
    update_user:getUser_email()//更新者（＝ログインユーザーのメールアドレス）
  },GlobalData.$ID_Token)
  .then(response => {
    //正常な結果が返ってきた場合の処理
    // response.data["status"]・・・status=0の時は正常終了、status=1のときは異常終了（データが削除できなかった等）。
    // response.data["message"]・・・API処理結果に付随するメッセージ。主にstatus=1（異常終了）の時に利用する
    
    if(response.data["status"] == 1){
        message.value = GlobalData.$axios_error;
        message_method.value = "delete_error";
        message_cat.value = 0;
        message_flag.value = true;
        contentMessage.value = MessageModal
    }else{
        // Cognitoの削除へ
        Cognito_Delete()
    }
  })
  .catch(error => {
        
        if(user_delete_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "delete_error";
            contentMessage.value = MessageModal
        }else{
            user_delete_error++
            setTimeout(function(){User_Delete()},"1000")
        }
  })
}

// Cognitoユーザーを削除する
let cognito_delete_error = 0
let Cognito_Delete = function(){

    let set_email = GlobalData.$User_email
    let user_id = GlobalData.user_id
    let ID_Token =  GlobalData.$ID_Token
    
    let send_array = {"user_id": user_id,"email":set_email}

        // 履歴登録
        const today = new Date()
        let set_date = new Date(today);
        set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
        set_date = new Date(set_date);
        rireki_kanri_add(set_date,7,user_id,0,0,0,0)

        axios.post(url + "Cognito_UserDelete",
        send_array,
        ID_Token)
        .then(response => {

        //正常な結果が返ってきた場合の処理
        // response.data["status"]・・・status=0の時は正常終了、status=1のときは異常終了（データが削除できなかった等）。
        // response.data["message"]・・・API処理結果に付随するメッセージ。主にstatus=1（異常終了）の時に利用する
        
        if(response.data["status"] == 1){
            message.value = GlobalData.$axios_error;
            message_method.value = "delete_error";
            message_cat.value = 0;
            message_flag.value = true;
            contentMessage.value = MessageModal
        }else{
            
            // ログイン情報を初期化
            GlobalData.$User_email = null
            GlobalData.user_id = null
            GlobalData.kencd = null
            GlobalData.city = null
            GlobalData.kengen = null
            GlobalData.shakyo_code = null

            sessionStorage.removeItem('return_shakyo')

            message.value = "アカウントの削除が完了しました。";
            message_method.value = "delete_OK";
            message_cat.value = 0;
            message_flag.value = true;
            contentMessage.value = MessageModal
        }
    })
    .catch(error => {
        if(cognito_delete_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "delete_error";
            contentMessage.value = MessageModal
        }else{
            cognito_delete_error++
            setTimeout(function(){Cognito_Delete()},"1000")
        }
    })
}

// 複数ユーザー対応 ユーザを削除する
let multipleuser_delete_error = 0
let multipleUser_Delete = function(user_id,role){

  axios.post(url + "TaikenUser_delete",
  {
    // 送信する値は「変数名:変数名」
    taikenuser_id: user_id,
    update_user:getUser_email()//更新者（＝ログインユーザーのメールアドレス）
  },GlobalData.$ID_Token)
  .then(response => {
    
    if(response.data["status"] == 1){
        message.value = GlobalData.$axios_error;
        message_method.value = "delete_error";
        message_cat.value = 0;
        message_flag.value = true;
        contentMessage.value = MessageModal
    }else{
        // 自分を消したら、cookieも消してアカウントユーザーに制御を移す
        if(user_id == cookies.get('switch_user') && role == false){
            cookies.remove('switch_user');  // 削除が成功したらcookieからも削除する。
        }

        // アカウントユーザーの削除の場合は、Cognitoユーザーの方も削除します。
        if(role == true){
            Cognito_Delete(role)
        }  else {
            // 履歴登録  アカウントユーザーでない場合の削除も履歴管理に登録する
            const today = new Date()
            let set_date = new Date(today);
            set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
            set_date = new Date(set_date);
            rireki_kanri_add(set_date,7,user_id,0,0,0,0)

        }
        // 削除後の画面遷移
        setTimeout(function(){multipleUser_Delete_logout() },"2000")
    }

})
  .catch(error => {
        
        if(multipleuser_delete_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "delete_error";
            contentMessage.value = MessageModal
        }else{
            multipleuser_delete_error++
            setTimeout(function(){multipleUser_Delete()},"1000")
        }
  })
}
// 削除後の画面遷移
let multipleUser_Delete_logout = function(role){

    login_check()

    if(role == true) {
        setTimeout(function(){Category_read("search")}, "1500");
    } else if(route.params.cmd == "mypage"){
        setTimeout(function(){Shakyo_code_check("mypage")}, "1500");
    } else {
        setTimeout(function(){Category_read("search")}, "1500");
    }
}

// チェックイン前に事前説明会の実績を確認
let jizen_jisseki_check_error = 0
const Jizen_jisseki_check = (jizenkensyu_no,id) =>{
     // ユーザーID・区分・プログラムIDを指定する
     axios.post(url+"Taikenuser_Jisseki", {taikenuser_id:GlobalData.user_id, program_kbn:2}, GlobalData.$ID_Token)
    .then(response => {
        let jisseki_jizen = response.data.jisseki  // 自分の実績レコード（事前説明会）を取得する
        let jizen_ok = 0

        let no_array = jizenkensyu_no.split(",")
        // 0 件の場合は参加できず
        // 1件以上あっても、チェックインしてなければ参加できず
        if(jisseki_jizen.length != 0){
            // プログラムに格納された事前説明会のNo.を確認
            
            for(let n = 0;n<no_array.length;n++){
                // 事前説明会の実績を確認
                for(let j = 0 ;j<jisseki_jizen.length;j++){
                    if(jisseki_jizen[j].syurui == 4 || jisseki_jizen[j].syurui == 5){
                        // 申込済みの事前説明会が「特殊（対面・オンライン）」の場合は問答無用で参加可能とする
                        if(jisseki_jizen[j].jokyo == '2'){
                          jizen_ok = 1
                        }
                    }else
                    // 事前説明会実績のNo.がプログラムに格納されたNo.と合致する場合
                    if(no_array[n] == jisseki_jizen[j].jizen_no){
                        
                        if(jisseki_jizen[j].sanka_flg == 1 ){
                            // 申込済みの事前説明会が任意参加の場合は、説明会参加の有無にかかわらず体験プログラムもOKとする
                            jizen_ok = 1
                        }else
                        // 申込済みの事前説明会が必須参加の場合は、その実績が参加済であればOK
                        if(jisseki_jizen[j].jokyo == '2'){
                            jizen_ok = 1
                        }
                    }
                }
            }
        }
        if(jizen_ok == 0){
            loading_flg.value = false
            message.value = "事前説明会へ参加していないため、プログラムへのチェックインができません。";
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "checkin_non_kensyu";
            contentMessage.value = MessageModal
        }else{
            checkin(id,1);
        }
    })
    .catch(error => {
        if(jizen_jisseki_check_error == 6){
            loading_flg.value = false
            message.value = "チェックインを行うにはログインしてください。";
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "checkin_non_login";
            contentMessage.value = MessageModal
        }else{
            jizen_jisseki_check_error++
            setTimeout(function(){Jizen_jisseki_check(jizenkensyu_no,id)},"1000")
            
        }
    })
}

//-------------------- チェックイン状態の確認
let checkin_error = 0
const checkin = (program_id,kbn,kensyu_date) => {

    //program_id = メインの体験プログラムID

    let program_name = "事前説明会"
    if(kbn == 1){
        program_name = "体験プログラム"
    }else if(kbn == 3){
        program_name = "事後集会"
    }
    
    // ユーザーID・区分・メインプログラムIDを指定する
    axios.post(url+"Taikenuser_Jisseki", {taikenuser_id:GlobalData.user_id, program_kbn:kbn, main_taiken_id:program_id}, GlobalData.$ID_Token)
    .then(response => {
        loading_flg.value = false
        // ソーシャルログイン時に利用する戻る社協英名、画面、IDを削除
        localStorage.removeItem('return_shakyo')
        localStorage.removeItem('checkin')
        localStorage.removeItem('checkin_id')
        
        let jisseki_all = response.data.jisseki_all

            // 今日の日付（参加日と比較用）
            const today = new Date()
            let set_date = new Date(today);
            set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
            set_date = new Date(set_date);
            let today_set = set_date.getFullYear()+"-"+(set_date.getMonth()+1)+"-"+set_date.getDate()
            console.log("today:"+set_date)

        if(jisseki_all.length == 0){
            
            message.value = "この"+program_name+"には申込んでいません。";
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "checkin_non_moushikomi";
            contentMessage.value = MessageModal
        }else{

            let set_jisseki = null


            //console.log("実績："+JSON.stringify(jisseki_all))

            for(let i = 0;i<jisseki_all.length;i++){
                    console.log(jisseki_all[i])
                    let check_jisseki = jisseki_all[i]
                    
                      //  console.log(check_jisseki)
                        console.log(check_jisseki.jokyo)
                        console.log(check_jisseki.shubetsu)

                    if(check_jisseki.jokyo != 9){

                        // 実績に紐づくものが体験プログラムで、プログラムの種別が「2：制作・寄付」だったらそのままチェックイン済みとする
                        if(check_jisseki.shubetsu == "2" && kbn == 1){
                            set_jisseki = check_jisseki
                            
                        }else if(kbn == 2 && (!kensyu_date || kensyu_date == '')){
                            // 実績に紐づくものが事前説明会で、説明会の開催日が未入力だったら、事前説明会のIDを持つ実績を格納する
                            if(check_jisseki.main_taiken_id == program_id){
                                set_jisseki = check_jisseki
                            }
                        }else{

                            let kaisai_set = Kaisai_setting(check_jisseki["kaisai_date"])
                            console.log("today_set:"+today_set +"/kaisai_set:"+ kaisai_set)
                            // 今日と同じ日付が存在する場合
                            if(today_set ==  kaisai_set){
                                set_jisseki = check_jisseki
                            }
                        }

                }
            }

            console.log(set_jisseki)
            if(set_jisseki == null){
                
                message.value = "本日はこの"+program_name+"の参加日ではありません。";
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "checkin_non_kaisai";
                contentMessage.value = MessageModal

            }else{
                // チェックイン済みならその旨を表示
                if(set_jisseki.jokyo > "1"){

                    let set_message = "本日はチェックイン済みです。"
                    if(set_jisseki.shubetsu == 2){
                        set_message = "このプログラムは提出済みです。"
                    }
                    param = {check_jisseki:set_jisseki,message:set_message,checkin_date:set_jisseki["checkin_date"],cityname:cityname }
                    content.value = UserCheckin
                }else{
                    // 参加前ならチェックイン処理へ
                    set_checkin(set_jisseki,set_jisseki.program_id,kbn,set_date,program_id)
                }
            }
        }

        

    })
    .catch(error => {
        if(checkin_error == 6){
            loading_flg.value = false
            message.value = "チェックインを行うにはログインしてください。";
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "checkin_non_login";
            contentMessage.value = MessageModal
        }else{
            checkin_error++
            setTimeout(function(){
                param = { cmd:route.params.cmd, id:route.params.id }
                call(param)
            },"1000")
            
        }
    })
}

//-------------------- チェックイン処理
let set_checkin_error = 0
const set_checkin = (set_jisseki,program_id,kbn,sanka_date,main_taiken_id) => {
    
    sanka_date.setHours(sanka_date.getHours()+9);
    let set_array = {user_id:GlobalData.user_id, program_kbn:kbn, program_id:program_id}
    // 実績に紐づくものが体験プログラムで、プログラムの種別が「1：施設・地域」だったら参加日を入力する
    if(set_jisseki.shubetsu == 1 && kbn == 1){
        set_array = {user_id:GlobalData.user_id, program_kbn:kbn, program_id:program_id, kaisai_date:sanka_date}
    }
    // 特殊説明会のフラグが立っていたらフラグも入れて送る
    if(set_jisseki.tokusyu){
        set_array.tokusyu = set_jisseki.tokusyu
    }
    
    axios.post(url+"Jisseki_CheckIn-Out",set_array, GlobalData.$ID_Token)
    .then(response => {
        // ソーシャルログイン時に利用する戻る社協英名、画面、IDを削除
        localStorage.removeItem('return_shakyo')
        localStorage.removeItem('checkin')
        localStorage.removeItem('checkin_id')

        
        // 履歴登録
        const today = new Date()
        let set_date = new Date(today);
        set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
        set_date = new Date(set_date);
        rireki_kanri_add(set_date,3,GlobalData.user_id,kbn,main_taiken_id,0,set_jisseki.moshikomi_count)

        // 今日の日付（参加日と比較用）
        let disp_date = new Date(today);
        disp_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
        disp_date = new Date(disp_date);

            
        param = {check_jisseki:set_jisseki,message:"チェックインしました。",checkin_date:disp_date,cityname:cityname }
        content.value = UserCheckin

    })
    .catch(error => {
//        alert("チェックイン時にエラーが発生しました。"+error)
        if(set_checkin_error == 6){
            loading_flg.value = false
            message.value = "チェックインを行うにはログインしてください。";
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "checkin_non_login";
            contentMessage.value = MessageModal
        }else{
            set_checkin_error++
            setTimeout(function(){
                    
                param = { cmd:route.params.cmd, id:route.params.id }
                call(param)
            },"1000")
        }
    })

}


//-------------------- 疑似的なチェックイン／アウト処理（テスト用）
let checkio_error = 0
const checkio = (user_id, kbn, id, date) => {
    axios.post(url+"Jisseki_CheckIn-Out", {user_id:user_id, program_kbn:kbn, program_id:id, kaisai_date:date}, GlobalData.$ID_Token)
    .then(response => {
        let status = response.data.status
        let message = response.data.message
        alert("status:"+status+"  message:"+message)
    })
    .catch(error => {
        if(checkio_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "check_error";
            contentMessage.value = MessageModal
        }else{
            checkio_error++
            setTimeout(function(){
                checkio(user_id, kbn, id, date) 
            },"1000")
        }
    })
}

//---------------------- アンケート＆感想文ページを開く
const quest_open = (program) => {
    
    let set_url = ""

    if(program.google_form == 2){
        set_url = Shakyo_data["splead_shakyo2"]
    }else if(program.google_form == 3){
        set_url = Shakyo_data["splead_shakyo3"]
        
    }else{
        set_url = Shakyo_data["splead_shakyo1"]
    }

    // ページを開く
    let url = set_url + GlobalData.user_id + ":" + program.program_id
    window.open(url)
}

//---------------------- アンケート＆報告書の提出
let quest_check_error = 0
const quest_check = (program_id,moshikomi_count) => {

    // 活動報告日時を設定
    let new_date = new Date()
    let set_date = new_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    set_date = new Date(set_date);
    set_date.setHours(set_date.getHours() + 9 );

    let send_array ={
        
        user_id: GlobalData.user_id,
        program_id:program_id,
        program_kbn:1,
        moshikomi_count:moshikomi_count,
        houkoku_date:set_date,
        update_user:GlobalData.$User_email//更新者（＝ログインユーザーのメールアドレス）
    }

    // 実績データをプログラムごとに更新する
    axios.post(url + "Jisseki_Programupdate",
        send_array,
        GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
        .then(response => {
            if(response.data["status"] == 1){
                alert("活動報告でエラーが発生しました。\n"+response.data["message"])
            }else{

                message.value = "活動報告が完了しました。";
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "jisseki_update";
                contentMessage.value = MessageModal
            }
    })
    .catch(error => {  
        if(quest_check_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "check_error";
            contentMessage.value = MessageModal
        }else{
            quest_check_error++
            setTimeout(function(){
                quest_check(program_id,moshikomi_count) 
            },"1000")
        }
    })
}


//---------------------- 参加証明をダウンロードする
let cert_check_error = 0
const cert_check = (program_id,syomei_count,moshikomi_count) => {
    axios.post(url+"Taikenuser_Jisseki", {taikenuser_id:GlobalData.user_id, program_kbn:1, main_taiken_id:program_id}, GlobalData.$ID_Token)
    .then(response => {

        console.log(response)
        
        let jisseki = response.data.jisseki
        let i = 0
        // 履歴登録時の日付設定
        const today = new Date()
        let set_date = new Date(today);
        set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
        set_date = new Date(set_date);
        // 履歴登録  参加証明書の実績が無い時(responseの実績データの参加証明日時がnull)に１度だけ出力する。 申込回数毎に参加証明書があるので申込回数の確認をする事
        for (i=0;i<jisseki.length;i++) {
            if(jisseki[i].moshikomi_count == moshikomi_count){
                if(jisseki[i].syomei_date == null){
                    rireki_kanri_add(set_date,5,GlobalData.user_id,1,program_id,0,moshikomi_count)
                    break
                }
            }
        }

        console.log(jisseki)

        // そのプログラムのすべての時間帯を一括処理する
        for (i=0;i<jisseki.length;i++) {
            if(jisseki[i].moshikomi_count == moshikomi_count){
                cert_rec(jisseki[i].jisseki_id,syomei_count,GlobalData.$User_email)
            }
        }
    })
    .catch(error => {
        if(cert_check_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "check_error";
            contentMessage.value = MessageModal
        }else{
            cert_check_error++
            setTimeout(function(){
                cert_check(program_id,syomei_count,moshikomi_count) 
            },"1000")
        }
    })
}

//---------------- 個々の時間帯の処理手続き（一括処理のために上から呼ばれる）
let cert_rec_error = 0
const cert_rec = (jisseki_id,syomei_count,user_email) => {
    let update_array = {jisseki_id:jisseki_id, update_user:user_email,syomei_count:(syomei_count+1)}
    if(syomei_count == 0){
        const today = new Date()
        let set_date = new Date(today);
        set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
        set_date = new Date(set_date);
        set_date.setHours(set_date.getHours() + 9 );
        update_array = {jisseki_id:jisseki_id, update_user:user_email,syomei_count:(syomei_count+1),syomei_date:set_date}
    }
    axios.post(url+"Jisseki_update", update_array, GlobalData.$ID_Token)
    .then(response => {
       location.href = location.protocol+'//'+location.host+"/"+cityname+"/Taiken/mypage"
    })
    .catch(error => {
        if(cert_rec_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "rec_error";
            contentMessage.value = MessageModal
        }else{
            cert_rec_error++
            setTimeout(function(){
                cert_rec(jisseki_id,syomei_count,user_email)
            },"1000")
        }
    })
}

//---------------- 予約のキャンセル
let cancel_error = 0
const cancel = (program_id, user_email,moshikomi_count) => {
    let json = { user_id: GlobalData.user_id,
                 program_id: program_id,
                 program_kbn: 1,
                 jokyo: '9',
                 moshikomi_count:moshikomi_count,
                 update_user: user_email,
                 cancel_date: new Date() }
    axios.post(url+"Jisseki_Programupdate", json, GlobalData.$ID_Token)
    .then(response => {
        
        // 履歴登録
        const today = new Date()
        let set_date = new Date(today);
        set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
        set_date = new Date(set_date);
        rireki_kanri_add(set_date,2,GlobalData.user_id,1,program_id,0,moshikomi_count)

        comp.value.canceled()
    })
    .catch(error => {
        if(cancel_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "cancel_error";
            contentMessage.value = MessageModal
        }else{
            cancel_error++
            setTimeout(function(){
                cancel(program_id, user_email)
            },"1000")
        }
        
    })
}


//---------------- ユーザ情報が登録済みか確認する
const user_check = (set_user_data) => {
    if(choson_code != ""){
        set_user_data.choson_code = choson_code
    }
    user_data = set_user_data
    // APIへ値を送信する
    axios.post(url+"TaikenUser_Check",
        set_user_data,
        GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
        .then(response => {

            if(response.data["status"] == 2){  // 異常終了時の処理
                alert("ユーザ情報の確認時にエラーが発生しました。")
            }else if(response.data["status"] == 1){  // 重複ユーザー有り
                let check_data = response.data["taikenusers"]
                let check_message = "生年月日、郵便番号、電話番号の同一ユーザーが存在します。\n"

                for(let c = 0;c<check_data.length;c++){

                    check_message += "\n氏名："+check_data[c]["username"]+"</span>" 
                    
                    check_message += "\n登録先："+check_data[c]["shakyo_name"]
                    check_message += "\nアカウント："
                    if(check_data[c]["provider"] == "line"){
                        check_message += "LINE"
                    }else if(check_data[c]["provider"] == "SignInWithApple"){
                        check_message += "Apple"
                    }else if(check_data[c]["provider"] == "Google"){
                        check_message += "Google"
                    }else{
                        check_message += "メールアドレス"
                    }

                }

                message.value = check_message+"\n\n上記の登録ユーザーでログインしますか？";
                message_cat.value = 1;
                message_flag.value = true;
                message_method.value = "user_check";
                contentMessage.value = MessageModal
                loading_flg.value = false
            }else{                             // 重複ユーザーなし
                user_add(set_user_data)
            }
        })
        .catch(error => {
                alert("ユーザ情報の登録時にエラーが発生しました。"+error)
            
        })
}


//---------------- ユーザ情報をDBへ登録する
let user_add_error = 0
const user_add = (set_user_data) => {
    
    if(choson_code != ""){
        set_user_data.choson_code = choson_code
    }
    user_data = set_user_data
  // APIへ値を送信する
  axios.post(url+"TaikenUser_add",
    set_user_data,
    GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
    .then(response => {
        if(response.data["status"] == 1){  // 異常終了時の処理
            alert("ユーザ情報の登録時にエラーが発生しました。")
        }else{                             // 正常終了時の処理
            new_userid = response.data["taikenuser_id"];

            if(multipleprofile == true){
                // 複数ユーザーの新規登録時のユーザーIDは、メール履歴のユーザーIDに使用する
                multiple_new_userid = new_userid
            } else {
                // 複数ユーザーの新規登録時は、グローバル変数は変更しない
                GlobalData.user_id = new_userid
                GlobalData.user_name = set_user_data.username
            }
            
            // 履歴登録
            const today = new Date()
            let set_date = new Date(today);
            set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
            set_date = new Date(set_date);
            rireki_kanri_add(set_date,0,new_userid,0,0,0)

            // cognitoのユーザー情報を更新
            setTimeout(function(){cognito_update(new_userid, set_user_data)},1000)
        }
    })
    .catch(error => {
        if(user_add_error == 16){
            loading_flg.value = false
            message.value = error + "<br>ユーザー登録で"+GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "check_error";
            contentMessage.value = MessageModal
        }else{
            user_add_error++
            setTimeout(function(){
                user_add(set_user_data)
            },"1000")
        }
	})
    // アカウントユーザーの新規登録時に確認しているcookieで保存している家族フラグを登録が終了したので削除している。
    if(cookies.isKey('family')){
            cookies.remove('family')
    }
}

let cognito_update_error = 0
// ユーザー情報とログイン情報を結び付ける
const cognito_update = (new_userid, user_data) => {
  
        // 複数ユーザーの新規登録時は、cognitoのユーザー情報は変更しない
        if(multipleprofile == false){
            set_habitat(new_userid, user_data.address_kencd, user_data.address_shi, "ippan",route.params.shakyo )
        }
        loading_flg.value = false
        message.value = "登録が完了しました。";
        message_cat.value = 0;
        message_flag.value = true;
        message_method.value = "complete_add";
        contentMessage.value = MessageModal
}


// ユーザー登録完了メールを送信する
const mail_user_create = () => {
    login_check()

    // メール実施フラグが立ってたらメールを送る
    if(mail_list[0].jisshi == true){

        // メールの内容を作成
        let set_title = mail_list[0].title
        let set_text = ""
        if(mail_list[0].naiyou!= "" && mail_list[0].naiyou != null){
            set_text = mail_list[0].naiyou.replace(/<br>/g, '\n')
        }
            
        // 各項目を変換

        // 申込者名
        set_text = set_text.replace(/<申込者名>/g, user_data.username)
        let mypage_url = location.protocol+"//"+location.host+"/"+cityname+"/Taiken/mypage"
        set_text = set_text.replace(/<マイページURL>/g, mypage_url)

        // 重要フラグをつけて送信APIへ
        mail_send(set_title,set_text,"user_add",mail_list[0].critical)
    }else{
        //メール送信の必要がなく、アンケートの必要もない場合はトップへ
        console.log("enqete_shubetsu："+enqete_shubetsu)
        if(enqete_shubetsu != 1){
            router.push("/"+cityname+"/Taiken")
        }else{
            loading_flg.value = false
            router.push("/"+cityname+"/Taiken/enqete/1")

        }
        
    }
}

// パスワード変更完了メールを送信する
const mail_renewal_create = () => {
    // メール実施フラグが立ってたらメールを送る
    if(mail_list[1].jisshi == true ){

        // メールの内容を作成
        let set_title = mail_list[1].title
        let set_text = ""
        if(mail_list[1].naiyou!= "" && mail_list[1].naiyou != null){
            set_text = mail_list[1].naiyou.replace(/<br>/g, '\n')
        }

            
        // 各項目を変換

        // 申込者名
        set_text = set_text.replace(/<申込者名>/g, user_data.username)
        let mypage_url = location.protocol+"//"+location.host+"/"+cityname+"/Taiken/mypage"
        set_text = set_text.replace(/<マイページURL>/g, mypage_url)

        // 重要フラグをつけて送信APIへ
        mail_send(set_title,set_text,"renewal",mail_list[1].critical)
    }else{
        //メール送信の必要がない場合は送らずにマイページへ
        router.push("/"+cityname+"/Taiken/mypage")
    }
}

//---------------- ユーザ情報を更新する
let user_update_error = 0
const user_update = (user_data) => {

    // ユーザーIDを格納
    user_data["taikenuser_id"] = GlobalData.user_id
    
  // APIへ値を送信する
  axios.post(url+"TaikenUser_update",
    user_data,
    GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
    .then(response => {
        if(response.data["status"] == 1){  // 異常終了時の処理
            
        }else{                             // 正常終了時の処理
            
            message.value = "更新が完了しました。";
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "complete_update";
            contentMessage.value = MessageModal
        }
    })
    .catch(error => {
        if(user_update_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "check_error";
            contentMessage.value = MessageModal
        }else{
            user_update_error++
            setTimeout(function(){
                user_update(user_data)
            },"1000")
        }
	})
}

//-- 設定画面の家族フラグが変更された時の更新処理
let user_family_update_error = 0
const user_family_update = (user_data) => {
    
  // 体験ユーザー更新APIへ値を送信する
  axios.post(url+"TaikenUser_update",
    user_data,
    GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
    .then(response => {
        if(response.data["status"] == 1){  // 異常終了時の処理
            
        }else{                             // 正常終了時の処理
            // 設定画面に家族フラグを表示するための修正
            family_flg_get(GlobalData.$API_URL, GlobalData.user_id)
            // router.push("/"+cityname+"/Taiken/setting" )
        }
    })
    .catch(error => {
        if(user_family_update_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "check_error";
            contentMessage.value = MessageModal
        }else{
            user_family_update_error++
            setTimeout(function(){
                user_family_update(user_data)
            },"1000")
        }
	})
}


//---------------- メールを送信する
let mail_send_error = 0
let mail_send_error_text = ""
let mail_send = function(set_title,set_text,type,critical){
    console.log("Mail_send type:"+type)
    set_text = set_text + "\n" + mail_send_error_text
    
    let send_data = {email:GlobalData.$User_email,title:set_title,text:set_text,reply_to:Shakyo_data.shakyo_email}

    // APIへ値を送信する
    axios.post(url+"Mail_send",
    send_data,
    GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
    .then(response => {
        if(response.data["status"] == 1){  // 異常終了時の処理
            alert(response.data["message"] )
        }else{
            // 正常終了時には送信履歴を追加する
            mail_rireki_add(set_title,set_text,type,critical)

        }
    })
    .catch(error => {
        if(mail_send_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "check_error";
            contentMessage.value = MessageModal
        }else{
            mail_send_error++
            mail_send_error_text = mail_send_error_text + "."
            setTimeout(function(){
                mail_send(set_title,set_text,type,critical)
            },"1000")
        }
    })
}

//---------------- 申込み時に受入先へのメール送信
let facility_mail_send_error = 0
let facility_mail_send = () => {

    // 受入先に送付するメールで使用する情報を取得する
    // 社協名、受入先名、受入先メールアドレス(送信先)、体験プログラム名、社協メールアドレス(返信先)
    axios.post(url+"Facility_Mail_read", {taiken_id:facility_taiken_id}, GlobalData.$ID_Token)
    .then(response => {
        if(response.data.status == 1){  // 異常終了時の処理
            alert(response.data.message)
            return
        }
        let rt = response.data.facility_info
        
        // タイトルに社協名を使用していたが、"XXX市"や"XXX町"となっており紛らわしいのでヘッダータイトル2を使用します。
        // ヘッダータイトル2が設定されていない場合は、社協名+"社会福祉協議会"とします。
        let m_title = ''
        if(rt.header_title2 == ''){
            m_title = rt.shakyo_name + '社会福祉協議会からの報告'
        } else {
            m_title = rt.header_title2 + 'からの報告'
        }
        let m_text = rt.facility_name + '様\n\n'
        m_text += 'お世話になっております。\n'
        m_text += rt.facility_name + '様の体験プログラム('+ rt.name +  ')に申込、又は申込の取消が発生しました。\n'
        m_text += '以下のURLをクリックして、内容を確認してください。\n'
        m_text += location.protocol+'//'+location.host+'/'+rt.choson_code+'/'+rt.facility_code+'/Shisetsu/MailLogin'

        facility_mailsend(rt.facility_email,m_title,m_text,rt.shakyo_email)

    })
    .catch(error => {
        if(facility_mail_send_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "get_error";
            contentMessage.value = MessageModal
        }else{
            facility_mail_send_error++
            setTimeout(function(){facility_mail_send()},"1000")
        } 
        
    })
}

// 体験プログラム申込みからのメッセージを受入先のメールに送信する
let facility_mailsend_error = 0
let facility_mailsend = function(email,mail_title,mail_honbun,shakyo_email){

  let send_data = {email:email,title:mail_title,text:mail_honbun,reply_to:shakyo_email}

    // APIへ値を送信する
    axios.post(url+"Mail_send",
    send_data,
    GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
    .then(response => {

    })
    .catch(error => {
        if(facility_mailsend_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "check_error";
            contentMessage.value = MessageModal
        }else{
            facility_mailsend_error++
            setTimeout(function(){facility_mailsend(email,mail_title,mail_honbun,shakyo_email)},"1000")
        }
    })
}

//---------------- メールの送信履歴を追加する
let mail_rireki_error = 0
let mail_rireki_add = function(set_title,set_text,type,critical){
    console.log("mail_rireki_add type:"+type)
    let syurui = 0
    if(type == "user_add"){
        // 新規ユーザー登録
        syurui = 0
    }else if(type == "moshikomi" ){
        // 申込終了時（プログラム）
        // キャンセル待ち申込は11、通常申込は2
        if(moshikomi_cancel_wait == 1){
            syurui = 11
        }else{
            syurui = 2
        }
    }else if(type == "jizen_moshikomi"){
        // 申込終了時（説明会）
        syurui = 7
    }else if(type == "renewal"){
        // パスワード更新時
        syurui = 1
    }else if(type == "houkoku"){
        // 報告書提出
        syurui = 5
    }else if(type == "enqete"){
        // アンケート提出
        syurui = 8
    }else if(type == "test"){
        // テスト送信
        syurui = 100
    }

    let user_id = 0
    if(GlobalData.user_id != null){
        // 複数ユーザー対応時は、登録されたユーザーIDを使用する
        if( multiple_new_userid == null){
            user_id = GlobalData.user_id
        } else {
            user_id = multiple_new_userid
            multiple_new_userid = null
        }
    }

    let set_choson_code = ""
    if(choson_code != ""){
        set_choson_code = choson_code
    }

    let send_data = {shakyo_name:route.params.shakyo,
        choson_code:set_choson_code,
        taikenuser_id:user_id,
        syurui:syurui,
        title:set_title,
        naiyou:set_text,
        critical:critical
    }

    // APIへ値を送信する
    axios.post(url+"Mail_rireki_add",
    send_data,
    GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
    .then(response => {
       
        // 履歴登録
        const today = new Date()
        let set_date = new Date(today);
        set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
        set_date = new Date(set_date);
        rireki_kanri_add(set_date,6,user_id,0,0,response.data["mail_rireki_id"])

            // 新規登録時にはトップへ
            if(type == "user_add"){
                console.log("enqete_shubetsu："+enqete_shubetsu)
                // アンケートの必要があればそちらへ
                if(enqete_shubetsu != 1){
                    router.push("/"+cityname+"/Taiken")
                }else{
                    loading_flg.value = false
                    router.push("/"+cityname+"/Taiken/enqete/1")

                }
            }
            // 各申込の完了時、またはパスワード変更時にはマイページへ
            if(type == "moshikomi" || type == "jizen_moshikomi" || type == "renewal"){
                router.push("/"+cityname+"/Taiken/mypage")
            }

            // アンケート提出の場合はウィンドウを出す
            if(type == "enqete"){
                loading_flg.value = false
                message.value = "回答を提出しました。";
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "answer_enqete_Update";
                contentMessage.value = MessageModal
            }
            
            // 報告書提出の場合はウィンドウを出す
            if(type == "houkoku"){
                loading_flg.value = false
                message.value = "活動報告が完了しました。";
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "jisseki_update";
                contentMessage.value = MessageModal
            }
    })
    .catch(error => {
        if(mail_rireki_error == 6){
            /*
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "check_error";
            contentMessage.value = MessageModal
            */
            // 新規登録時にはトップへ
            if(type == "user_add"){
                router.push("/"+cityname+"/Taiken")
            }
            // 申込み完了時、またはパスワード変更時にはマイページへ
            if(type == "moshikomi" || type == "renewal"){
                router.push("/"+cityname+"/Taiken/mypage")
            }
            // 報告書提出の場合はウィンドウを出す
            if(type == "houkoku"){
                
                message.value = "活動報告が完了しました。";
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "jisseki_update";
                contentMessage.value = MessageModal
            }
        }else{
            mail_rireki_error++
            setTimeout(function(){
               mail_rireki_add(set_title,set_text,type,critical)
            },"1000")
        }
       // alert("メール履歴登録処理でエラーが発生しました。"+error)

            
    })
}

//---------------- ユーザーIDを指定してメールの送信履歴を取得する
let mail_rireki_read_error = 0
let mail_rireki_read = function(cat){

    if(cat == "enqete" || cat == "report"){
        return
    }

    let user_id = 0
    if(GlobalData.user_id != null){
        user_id = GlobalData.user_id
    }

    let set_choson_code = ""
    if(choson_code != ""){
        set_choson_code = choson_code
    }

    let send_data = {shakyo:route.params.shakyo,
        choson_code:set_choson_code,
        taikenuser_id:user_id}


    // APIへ値を送信する
    axios.post(url+"Mail_rireki_get",
    send_data,
    GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
    .then(response => {
        
        if(response.data["status"] == 1){
            alert("エラーが発生しました。\n"+response.data["message"])
        }else{
            mail_rireki_list = response.data.mail_rireki
            midoku_count.value = 0 // 未読カウントを初期化
            let critical_midoku_count = 0 // 重要メールの未読が何件あるか

            for(let i = 0;i<mail_rireki_list.length;i++){
                let mail_rireki = mail_rireki_list[i]

                // 未読メールがあった場合はカウントを増やす
                if(mail_rireki.kidoku == 0)  {
                    midoku_count.value++
                    // 重要メールの場合は重要未読カウントを増やす
                    if(mail_rireki.critical == true){
                        critical_midoku_count++
                    }
                }
            }

            if(cat == "notification"){
                param = {'results':mail_rireki_list}

                // メール送信履歴を表示 
                content.value = UserNotification
                    param_left = {header_logo:header_logo,
                    header_title1:header_title1,
                    header_title2:header_title2,
                    title_style1:title_style1_pc.value,
                    title_style2:title_style2_pc.value}
                contentLeft.value = UserMyLeftbar

                loading_flg.value = false

                render.value = render.value + 1
                Rightbar_setting()
                //setTimeout(function(){Rightbar_setting()},"1000")

            }else{
                
                // お知らせページ以外で重要メールの未読がある場合は、お知らせページに移動させる
                if(critical_midoku_count != 0){
                    
                    message.value = "<b style='color:red'>大切なメッセージが届いています。</b>";
                    message_cat.value = 4; // 未読専用フラグ
                    message_flag.value = true;
                    message_method.value = "critical_midoku";
                    contentMessage.value = MessageModal
                }

            }
        }

    })
    .catch(error => {
        if(mail_rireki_read_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "check_error";
            contentMessage.value = MessageModal
        }else{
            mail_rireki_read_error++
            setTimeout(function(){
                mail_rireki_read(cat)
            },"1000")
        }
       
    })
}
    // 回答するアンケート・報告書の設問を取得する
    let form_read_error = 0
    let Form_Dynamo_read = function(form_syurui,form_no,program_id) { 
            
        let get_syurui = "report"
        if(form_syurui == 1){
            get_syurui = "enqete"
        }

        let set_url = url + "Form_Dynamo_read"
        axios.post(set_url,
        {
            action:"get_forms_new",
            choson_code:route.params.shakyo,
            syurui:get_syurui,
            form_nos:[form_no]
        }) 
        .then(response => {
            // 子コンポーネントに送る値を格納
            // UserFormへ送る値
            // 設問データは一件しか取得してないので配列の1番目を代入
            loading_flg.value = false
            
            if(response.data.data.length == 0){
                    
                    message.value = "設問が用意されていません。恐れ入りますが、所属する事業者（社協等）にお問い合わせください。";
                    message_cat.value = 0;
                    message_flag.value = true;
                    message_method.value = "form_not_found";
                    contentMessage.value = MessageModal
            }else{
                console.log(response.data.data)
                let results = response.data.data[0]
                param = {'results':results,"syurui":form_syurui,"no":form_no,"program_id":program_id}
                    
                // 回答コンポーネント（UserForm）を表示
                content.value = UserForm
                Page_scroll(0)

            }
        })
        .catch(error => {
            
            if(form_read_error == 6){
                message.value = error + GlobalData.$axios_error;
                message_method.value = "update_error";
                message_cat.value = 0;
                message_flag.value = true;
                contentMessage.value = MessageModal
            }else{
                form_read_error++
                setTimeout(function(){Form_Dynamo_read(form_syurui,form_no,program_id)},"1000")
            }
        })

    }
    
    // アンケート・報告書の回答を追加する
    let form_add_error = 0
    function Form_answer_add(answer_list,form_syurui,form_no,form_title,program_id,taikenuser_id,form_id,mail_answer,moshikomi_count){

        let set_syurui = "report"
        if(form_syurui == 1){
            set_syurui = "enqete"
        }
        let set_array = {action:"create_answer",
            choson_code:route.params.shakyo,
            form_id:parseInt(form_id),
            taikenuser_id:taikenuser_id,
            program_id:program_id,
            title:form_title,
            answer_list:answer_list,
            syurui:set_syurui,
            form_no:form_no}
   //     console.log(form_id)


        let set_url = url + "Form_Dynamo_add"
        axios.post(set_url,
        set_array) 
        .then(response => {
            // エラーがあった場合
            if(response.data.status == 1){
                message.value = "回答保存時にエラーが発生しました。"+response.data.message;
                message_method.value = "error";
                message_cat.value = 0;
                message_flag.value = true;
                contentMessage.value = MessageModal
            }else{
                // 種類（アンケート or 報告書）によって処理を変更する
                if(form_syurui == 1){
                    // アンケート提出メール実施フラグが立ってたらメールを送る
                    if(mail_list[8].jisshi == true ){
                        enqete_mail_create(mail_answer)
                    }else{
                        message.value = "回答を提出しました。";
                        message_cat.value = 0;
                        message_flag.value = true;
                        message_method.value = "answer_enqete_Update";
                        contentMessage.value = MessageModal
                        loading_flg.value = false
                    }
                }else{
                    houkoku_update(program_id,mail_answer,moshikomi_count)
                }
            }

        }).catch(error => {
            if(form_add_error == 6){
                message.value = error + GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "get_error";
                contentMessage.value = MessageModal
            }else{
                form_add_error++
                setTimeout(function(){Form_answer_add(answer_list,form_syurui,form_no,form_title,program_id,taikenuser_id,form_id,mail_answer,moshikomi_count)},"1000")
            }
        })

    }

//---------------------- 報告書提出フラグを立てる
let houkoku_update_error = 0
const houkoku_update = (program_id,mail_answer,moshikomi_count) => {

    loading_flg.value = false

    // 活動報告日時を設定
    let new_date = new Date()
    let set_date = new_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    set_date = new Date(set_date);
    set_date.setHours(set_date.getHours() + 9 );

    let send_array ={
        
        user_id: GlobalData.user_id,
        taiken_id:program_id,
        program_kbn:1,
        moshikomi_count:moshikomi_count,
        houkoku_date:set_date,
        update_user:GlobalData.$User_email//更新者（＝ログインユーザーのメールアドレス）
    }

    // 実績データをプログラムごとに更新する
    axios.post(url + "Jisseki_Teishutsu",
        send_array,
        GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
        .then(response => {
            if(response.data["status"] == 1){
                alert("活動報告でエラーが発生しました。\n"+response.data["message"])
            }else{

                // 履歴登録
                const today = new Date()
                let set_date = new Date(today);
                set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
                set_date = new Date(set_date);
                rireki_kanri_add(set_date,4,GlobalData.user_id,1,program_id,0,moshikomi_count)

                // 報告書メール実施フラグが立ってたらメールを送る
                if(mail_list[5].jisshi == true ){
                    houkoku_mail_create(program_id,mail_answer)
                }else{
                    message.value = "活動報告が完了しました。";
                    message_cat.value = 0;
                    message_flag.value = true;
                    message_method.value = "jisseki_update";
                    contentMessage.value = MessageModal
                }
            }
    })
    .catch(error => {  
        if(houkoku_update_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "update_error";
            contentMessage.value = MessageModal
        }else{
            houkoku_update_error++
            setTimeout(function(){
                houkoku_update(program_id,mail_answer,moshikomi_count)
             },"1000")
        }
    })
}

// アンケート提出完了メールを送信する
let enqete_mail_create = function(mail_answer){
   
    // メールの内容を作成
    let set_title = mail_list[8].title
    let set_text = ""
    if(mail_list[8].naiyou != "" && mail_list[8].naiyou != null){
        set_text = mail_list[8].naiyou.replace(/<br>/g, '\n')
    }
                
    // 各項目を変換

    // 申込者名
    set_text = set_text.replace(/<申込者名>/g, GlobalData.user_name)

    let mypage_url = location.protocol+"//"+location.host+"/"+cityname+"/Taiken/mypage"
    set_text = set_text.replace(/<マイページURL>/g, mypage_url)
            
    // 回答内容
    set_text = set_text.replace(/<回答内容>/g, mail_answer)

    // 重要フラグを付けて送信APIへ
    mail_send(set_title,set_text,"enqete",mail_list[8].critical)
       
}

// 報告書提出完了メールを送信する
let houkoku_mail_error = 0
let houkoku_mail_create = function(program_id,mail_answer){
    axios.post(url+"Taiken_read", {taiken_id:program_id})
       .then(response => {
            let program = response.data
            // メールの内容を作成
            let set_title = mail_list[5].title
            let set_text = ""
            if(mail_list[5].naiyou != "" && mail_list[5].naiyou != null){
                set_text = mail_list[5].naiyou.replace(/<br>/g, '\n')
            }

                
            // 各項目を変換

            // 申込者名
            set_text = set_text.replace(/<申込者名>/g, GlobalData.user_name)

            // 体験プログラム・内容
            let set_naiyo = "名称："+program.name+"\n"
            set_naiyo += "場所："+program.k_jusyo+"\n"
            set_naiyo += "内容："+program.naiyou

            set_text = set_text.replace(/<体験プログラム・内容>/g, set_naiyo)
            let mypage_url = location.protocol+"//"+location.host+"/"+cityname+"/Taiken/mypage"
            set_text = set_text.replace(/<マイページURL>/g, mypage_url)
            
            // 回答内容
            set_text = set_text.replace(/<回答内容>/g, mail_answer)

            // 重要フラグを付けて送信APIへ
            mail_send(set_title,set_text,"houkoku",mail_list[5].critical)
    })
    .catch(error => {
        if(houkoku_mail_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "update_error";
            contentMessage.value = MessageModal
        }else{
            houkoku_mail_error++
            setTimeout(function(){
                houkoku_mail_create(program_id,mail_answer)
            },"1000")
        }
    })
}


//---------------- 履歴を登録する
let rireki_add_error = 0
let rireki_kanri_add = function(toroku_date,kubun,taikenuser_id,program_kbn,program_id,mail_rireki_id,moshikomi_count){
    let set_choson_code = ""
    if(choson_code != ""){
        set_choson_code = choson_code
    }
    let send_data = {shakyo_name:route.params.shakyo,
        choson_code:set_choson_code,
        taikenuser_id:taikenuser_id,
        program_kbn:program_kbn,
        program_id:program_id,
        mail_rireki_id:mail_rireki_id,
        kubun:kubun,
        moshikomi_count:moshikomi_count,
        toroku_date:toroku_date,
        update_user:GlobalData.$User_email}

        // APIへ値を送信する
        axios.post(url+"Rireki_add",
        send_data,
        GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
        .then(response => {


            /*
            alert(JSON.stringify(response))
            if(response.data["status"] == 1){

                message.value = "履歴登録でエラーが発生しました。\n"+response.data["message"];
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "rireki_add_error";
                contentMessage.value = MessageModal
            }*/
            
        })
        .catch(error => {
            if(rireki_add_error == 6){
                message.value = error + GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "update_error";
                contentMessage.value = MessageModal
            }else{
                rireki_add_error++
                setTimeout(function(){
                    rireki_kanri_add(toroku_date,kubun,taikenuser_id,program_kbn,program_id,mail_rireki_id,moshikomi_count)
                },"1000")
            }
        })
    }

    // メッセージを表示するウィンドウでOKを押された時
    let OK_message = function(){ 
        Close_message();//メッセージを表示するウィンドウを閉じる

        // 実績データ登録後、申込み完了メールを送信し、マイページへ移動する
        if(message_method.value == "jisseki_add"){
           mail_moshikomi_create()
        }else if(message_method.value == "jizen_jisseki_add"){
            mail_jizen_create()
        }else if(message_method.value == "Jisseki_add_error"){
            // 実績が追加できなかった時は一覧に戻す
            router.push("/"+route.params.shakyo+"/Taiken")
        }else if(message_method.value == "user_error"){
            // ログインはできるが、ユーザ情報の登録がされていない場合、登録画面へ移動させる
            /*
            param_left = {header_logo:header_logo,
                header_title1:header_title1,
                header_title2:header_title2,
                title_style1:title_style1_pc.value,
                title_style2:title_style2_pc.value}
            contentLeft.value = Leftbar
            param = { cmd:"user_toroku"}
            call(param)*/
            
            router.push("/"+route.params.shakyo+"/Taiken/user_toroku")
        }else if(message_method.value =="complete_add"){
            // ユーザー新規登録後、メールを送信し、トップページへ移動する
            loading_flg.value = true
            mail_user_create()
            // 新規ユーザーに切り替える
            switch_user()

        }else if(message_method.value == "complete_update"){
            // ユーザー更新後、マイページHOMEへ移動する
            router.push("/"+route.params.shakyo+"/Taiken/mypage")

        }else if(message_method.value == "checkin_non_kaisai"
                 || message_method.value == "checkin_non_moushikomi"
                 || message_method.value ==  "checkin_non_kensyu"){
            // チェックイン時
            // １：申込んではいるが開催日ではない
            // ２：申込んでいない
            // ３；前提となる事前説明会への参加が行われていない
            
            call({ cmd:"mypage" })
            //router.push("/"+route.params.shakyo+"/Taiken/mypage")

        }else if(message_method.value == "checkin_flg_end"){
            // 二次元コードからチェックインをしたが、社協側設定で利用しない場合はトップへ戻る
            location.href = location.protocol+'//'+location.host+"/"+route.params.shakyo+"/Taiken"
        }else if(message_method.value == "checkin_non_login"){
            // チェックイン時、ログイン状態が確認できない
            call({ cmd:"login" })
        }else if(message_method.value == "jisseki_update"){
            // 実績関係の更新を行った後、マイページHOMEへ移動する
            param = { cmd:"mypage" }
            call(param)
        }else if(message_method.value == "line_login_error"){
            //LINEで新規登録・ログイン時にエラーが起きたらトップへ戻る
            location.href = location.protocol+'//'+location.host+"/"+route.params.shakyo+"/Taiken"
        }else if(message_method.value == "delete_OK"){
            //アカウント削除完了したらトップへ戻る
            location.href = location.protocol+'//'+location.host+"/"+route.params.shakyo+"/Taiken"
        }else if(message_method.value == "answer_Update"){
            // 改めてフォームを読む
            //Form_get()
            // 報告書の回答を行った後、マイページHOMEへ移動する
            router.push("/"+route.params.shakyo+"/Taiken/mypage")
        }else if(message_method.value == "answer_enqete_Update"){
            // 改めてフォームを読む
            //Form_get()
            // アンケートの回答を行った後、トップページへ移動する
            router.push("/"+route.params.shakyo+"/Taiken/home")
            //param = { cmd:"home" }
            //call(param)
            //location.href = location.protocol+'//'+location.host+"/"+route.params.shakyo+"/Taiken"
        }else if(message_method.value == "user_check"){
            loading_flg.value = true
            // 重複ユーザーが存在するが、登録を続ける
            user_add(user_data)
        }else if(message_method.value == "shakyo_error"){
            // 閲覧中の社協とユーザーの所属社協が違ったので、移動する場合
            location.href = location.protocol+'//'+location.host+"/"+GlobalData.shakyo_code+"/Taiken"
        }else if(message_method.value == "user_mitoroku"){
            
            // ユーザー情報（プロフィール）が未登録の場合は新規登録画面へ飛ばす
            router.push("/"+route.params.shakyo+"/Taiken/user_toroku")
        }else if(message_method.value == "critical_midoku"){
            // 未読の重要メールがあった場合、お知らせページへ移動
            router.push("/"+route.params.shakyo+"/Taiken/notification")
            
        }else if(message_method.value == "form_not_found"){
            // アンケート・報告書の設問が用意されていない場合、マイページへ戻す
            router.push("/"+route.params.shakyo+"/Taiken/mypage")
            
        }
        //

    }

    // メッセージを表示するウィンドウを閉じる
    let Close_message = function(){
        message_flag.value = false;
        contentMessage.value = null
    }

    
    // 上にスクロールする：height＝位置（上から何pxか）
    let Page_scroll = function(height){
        //「behavior: 'smooth'」はスムーズなスクロール。「behavior: 'auto'」だと一瞬で移動する

        /*
        document.getElementById("vy_body").scrollIntoView({
            behavior: 'auto',
            block:'start'
        })*/


        scrollTo(0,0)
        window.scrollTo({
            top: 0,
            behavior: 'auto'
        })
    }
    
// スマホ用・マイページボタン（icon_mypage.png）をクリックした時の動作
const Smart_mypage = function() {
    
    // 検索フォームが開かれてるときは閉じる
    if( Smart_search_open.value == 1){
        
        
        if(route.params.cmd == "mypage"){
            
            param = { cmd:"mypage" }
            call(param)
            
        }else{
            router.replace("/"+cityname+"/Taiken/mypage")
        }
        Smart_search_open.value = 0
        
        displayStatus.value = false
            nextTick(() => {
            displayStatus.value = true
        })
    }else{
        
        // ログイン中の場合
        if ( GlobalData.$User_email) {
            // マイページへ移動させない
            if(route.params.cmd == "mypage"){
                /*
                param = { cmd:"mypage" }
                call(param)*/
            }else{
                router.replace("/"+cityname+"/Taiken/mypage" )
            }
        }else{
            // 未ログイン時の場合、URLによって動作を変更
            if(route.params.cmd == "detail" || route.params.cmd == "checktaiken" || route.params.cmd == "checkjizen" || route.params.cmd == "checkjigo"){
                // URLを変えずに直接ログイン処理
                call({ cmd:"login" })
            }else{
                // URLを変更してログイン
                router.replace("/"+cityname+"/Taiken/login" )
            }

        }
    }
    
}

// 右バーのログイン状態を更新
let rightbar_setting_error = 0
const Rightbar_setting = function(){
    login_check()
    contentRight.value = UserRightBar 
    loading_flg.value = false
    displayStatus.value = false
        nextTick(() => {
        displayStatus.value = true
    })

    setTimeout(function(){
        // ユーザーの社協コードが確認できない場合は、移動の必要がない
        if(GlobalData.shakyo_code == null){
            return
        }
        
        console.log(GlobalData.shakyo_code +"/"+ cityname)
        // ユーザーの社協コードとURLの社協コードが同じ場合は、移動の必要がない
        if(GlobalData.shakyo_code == cityname){
            return
        }

        // ユーザー情報未登録の場合、他の処理で移動するのでこちらでは移動の必要がない
        if(not_user_add == 1){
            return
        }
        
        // ユーザーの社協コードを利用して呼び出し
        axios.post(url+"Shakyo_read", 
                {shakyo:GlobalData.shakyo_code}
                ).then(response => {
                    shozoku_name.value = response["data"].shakyo_name
                            
                    loading_flg.value = false
                    message.value = "あなたの登録先は、<br><span style='color:red'><b>"+shozoku_name.value+"</b></span><br>です。";
                    message_cat.value = 3;
                    message_flag.value = true;
                    message_method.value = "shakyo_error";
                    contentMessage.value = MessageModal
            })
        .catch(error => {
            if(rightbar_setting_error == 6){
                message.value = error + GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "update_error";
                contentMessage.value = MessageModal
            }else{
                rightbar_setting_error++
                setTimeout(function(){
                    Rightbar_setting()
                },"1000")
            }
        })
    },"500")
}

// ユーザー登録画面を表示
const toroku_disp = () =>{
    setTimeout(function(){Rightbar_setting()},"1000")
    param = {user_flg:user_flg,
             disp_flg:disp_flg,
             hissu_flg:hissu_flg,
             user_free_text1:user_free_text1,
             user_free_text2:user_free_text2,
             user_free_select1:user_free_select1,
             user_free_select2:user_free_select2,
             user_free_choice1:user_free_choice1,
             user_free_choice2:user_free_choice2,
             ippan_select:ippan_select,
             pc_age:pc_age,
             other_sanka:other_sanka,
             gakusei_kbn_list:gakusei_kbn_list,
             gakusei_meisho_list:gakusei_meisho_list,
             gakusei_sanka:gakusei_sanka,
             multipleprofile:false} 

    render.value = render.value + 1
    title = "プロフィール登録"
    content.value = UserToroku
            
    param_left = {header_logo:header_logo,
                header_title1:header_title1,
                header_title2:header_title2,
                title_style1:title_style1_pc.value,
                title_style2:title_style2_pc.value}
    contentLeft.value = Leftbar
}

let multipleprofile_disp_error = 0
// ログイン後の家族の登録(右メニューからの新規登録)処理
const multipleprofile_disp = (multipleprofile) =>{
    // setTimeout(function(){Rightbar_setting()},"1000")

    // アカウントユーザー情報の取得      郵便番号・住所や電話番号(登録対象が未成年だった時の保護者電話番号に使用) 登録時の初期値の設定に使用する。
  let res = null
  axios.post(url + "TaikenAccountUser_read",
  {
    taikenuser_id: GlobalData.user_id
  },GlobalData.$ID_Token)
  .then(response => {
    res = response.data

    if(res["status"] == 1){
        // ローディングアイコンを非表示
        loading_flg.value = false
        message.value = GlobalData.$axios_error;
        message_method.value = "accountuser_get_error";
        message_cat.value = 0;
        message_flag.value = true;
        contentMessage.value = MessageModal
    }else{
        param = {user_flg:user_flg,
                disp_flg:disp_flg,
                hissu_flg:hissu_flg,
                user_free_text1:user_free_text1,
                user_free_text2:user_free_text2,
                user_free_select1:user_free_select1,
                user_free_select2:user_free_select2,
                user_free_choice1:user_free_choice1,
                user_free_choice2:user_free_choice2,
                ippan_select:ippan_select,
                pc_age:pc_age,
                other_sanka:other_sanka,
                gakusei_kbn_list:gakusei_kbn_list,
                gakusei_meisho_list:gakusei_meisho_list,
                gakusei_sanka:gakusei_sanka,
                multipleprofile:multipleprofile,   // 家族登録フラグ(True:家族などのログインできないユーザー False:ログインユーザー)
                family_count:res["family_count"],  // 家族の人数
                accountuser:res["accountuser"]}    // アカウントユーザーの情報

        render.value = render.value + 1
        title = "プロフィール登録"
        content.value = UserToroku
                
        param_left = {header_logo:header_logo,
                    header_title1:header_title1,
                    header_title2:header_title2,
                    title_style1:title_style1_pc.value,
                    title_style2:title_style2_pc.value}
        contentLeft.value = Leftbar

        // ローディングアイコンを非表示
        loading_flg.value = false
    }
})
  .catch(error => {
        
        if(multipleprofile_disp_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "accountuser_get_error";
            contentMessage.value = MessageModal
        }else{
            multipleprofile_disp_error++
            setTimeout(function(){multipleprofile_disp(multipleprofile)},"1000")
        }
  })

}

// 複数ユーザーで切り替えるユーザーのリストを表示する
let multipleprofile_switch_error = 0
function multipleprofile_switch(u_id) {
    loading_flg.value = true
    axios.post(url+"MultipleUser_get",{
        taikenuser_id:GlobalData.user_id,
        mode:1
    }).then(response => {
        let res = response.data
        if(res["status"] == 1){
            alert("エラーが発生しました。\n"+response.data["message"])
            return
        }else{
            multipleprofile_switch_flg.value = true
            user_id.value = u_id  // ユーザーID
            param_multiple.value = {multipleusers:res["multipleusers"]}  // ユーザー切替対象のユーザーのデータ
            contentUserSwitch.value = UserSwitch  // ユーザー切替画面の表示

            loading_flg.value = false
        }

    })
    .catch(error => {
        if(multipleprofile_switch_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "multipleprofile_switch_error";
            contentMessage.value = MessageModal
        }else{
            multipleprofile_switch_error++
            setTimeout(function(){
                multipleprofile_switch()
            },"1000")
        }
       
    })
}

// メッセージを表示するウィンドウを閉じる
let multipleprofile_close = function(){
    multipleprofile_switch_flg.value = false;
    contentUserSwitch.value = null
}

let account_userid = 0
let selected = false
let family_count = 0

// 家族の有無フラグを取得する
let family_flg_get_error = 0
function family_flg_get(url,user_id){
  let res = null
  axios.post(url + "TaikenAccountUser_read",
  {
    taikenuser_id: user_id
  },GlobalData.$ID_Token)
  .then(response => {

    
    if(response.data["status"] == 1){
        loading_flg.value = false
        message.value = GlobalData.$axios_error;
        message_method.value = "family_flg_get_error";
        message_cat.value = 0;
        message_flag.value = true;
        contentMessage.value = MessageModal
    }else{
        if(response.data["accountuser"]){
          res = response.data["accountuser"]
          account_userid = res["taikenuser_id"]
          selected = res["family"] 
          // 登録されている家族数を取得する。
          multiple_count_get(url, user_id)
        }
    }
})
  .catch(error => {
        
        if(family_flg_get_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "family_flg_get_error";
            contentMessage.value = MessageModal
        }else{
            family_flg_get_error++
            setTimeout(function(){family_flg_get(url,user_id)},"1000")
        }
  })
}

// 家族の人数を取得後、設定画面を表示する。
let multiple_count_get_error = 0
function multiple_count_get(url, user_id){
  let res = null

  axios.post(url + "MultipleUser_get",
  {
    // 送信する値は「変数名:変数名」
    taikenuser_id: user_id
  },GlobalData.$ID_Token)
  .then(response => {
    
    if(response.data["status"] == 1){
        message.value = GlobalData.$axios_error;
        message_method.value = "multiple_count_get_error";
        message_cat.value = 0;
        message_flag.value = true;
        contentMessage.value = MessageModal
    }else{
        family_count = response.data["multipleusers"].length
    }
    loading_flg.value = false

    param = {account_userid:account_userid,
            selected:selected,
            family_count:family_count
    }

    render.value = render.value + 1

    content.value = UserMySetting
        
    param_left = {header_logo:header_logo,
        header_title1:header_title1,
        header_title2:header_title2,
        title_style1:title_style1_pc.value,
        title_style2:title_style2_pc.value
    }
    contentLeft.value = UserMyLeftbar

    Rightbar_setting()
    //setTimeout(function(){Rightbar_setting()},"1000")

})
  .catch(error => {
        
        if(multiple_count_get_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "multiple_count_get_error";
            contentMessage.value = MessageModal
        }else{
            multiple_count_get_error++
            setTimeout(function(){multiple_count_get(url, user_id)},"1000")
        }
  })
}

let code_error_count = 0

// ユーザーの社協コードをチェック
const Shakyo_code_check = function(cmd) {

    // 戻り先の社協が記録されているかどうか
    // 記録されていて、なおかつ今のURLと違う場合はそちらに飛ばす
    let return_city = ""
    if(localStorage.getItem('return_shakyo') != null
        && localStorage.getItem('return_shakyo') != undefined){
        return_city = localStorage.getItem('return_shakyo')

        // 閲覧中の社協と戻り先の社協が別なら移動する
        if(return_city != route.params.shakyo){
            location.href = location.protocol+'//'+location.host+"/"+return_city+"/Taiken"
            return
        }
        // ユーザー情報が作られていない等で、ユーザーの社協コードが確認できない場合
        if(GlobalData.shakyo_code == null){
            setTimeout(function(){Rightbar_setting()},"1000")
        }
   /*
        // ユーザー情報が作られていない等で、ユーザーの社協コードが確認できない場合
        if(GlobalData.shakyo_code == null){
            
            // login_check()  // Rightbar_settingメソッド内でlogin_checkを行っている。

            setTimeout(function(){Rightbar_setting()},"1000")

            localStorage.removeItem('return_shakyo') 
            not_user_add = 1
            GlobalData.shakyo_code = return_city
            
            router.push("/"+route.params.shakyo+"/Taiken/user_toroku")
            
            return
        }else if(return_city != route.params.shakyo){
            location.href = location.protocol+'//'+location.host+"/"+return_city+"/Taiken"
            return
        }
        */
    }


    console.log(cmd)
    // homeから来た場合は分類を読みに行く
    if(cmd == "home"){
        // ユーザーIDがあるなら先にメールの履歴確認
        if(GlobalData.user_id != null){
            mail_rireki_read("search")
        }
    }else if(cmd == "mypage"){
        my_jisseki()
    }else if(cmd == "Jizen"){
        jizen_dsp(cmd)
    }
    localStorage.removeItem('return_shakyo') 
}

//---------------- 事前説明会情報取得
let jizen_qr_error = 0
const jizen_qr = (proc,jizen_id,user_id) => {

    let send_array = { jizen_id : jizen_id }

    axios.post(url+"Jizen_read", send_array, GlobalData.$ID_Token)
    .then(response => {
        let res = response.data
        if(res["status"] == 1){
            alert("エラーが発生しました。\n"+response.data["message"])
            return
        }else{

            param = {"proc":proc,"jizen_id":jizen_id,"user_id":user_id,"jizen":res}

            // 子コンポーネントをQRコード表示に切替
            content.value = UserJizenCode
            // 子コンポーネントを再レンダリング
            // Rendering_child()
        }
    })
    .catch(error => {
        if(jizen_qr_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "get_error";
            contentMessage.value = MessageModal
        }else{
            jizen_qr_error++
            setTimeout(function(){jizen_qr(proc,taiken_id,user_id)},"1000")
        }
        
    })
}

//---------------- 体験プログラム情報取得
let taiken_qr_error = 0
const taiken_qr = (proc,taiken_id,user_id) => {

    let send_array = { taiken_id : taiken_id }

    axios.post(url+"Taiken_simple_read", send_array, GlobalData.$ID_Token)
    .then(response => {
        let res = response.data
        if(res["status"] == 1){
            alert("エラーが発生しました。\n"+response.data["message"])
            return
        }else{

            param = {"proc":proc,"taiken_id":taiken_id,"user_id":user_id,"taiken":res["taiken"]}

            // 子コンポーネントをQRコード表示に切替
            content.value = UserTaikenCode
            // 子コンポーネントを再レンダリング
            // Rendering_child()
        }
    })
    .catch(error => {
        if(taiken_qr_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "get_error";
            contentMessage.value = MessageModal
        }else{
            taiken_qr_error++
            setTimeout(function(){taiken_qr(proc,taiken_id,user_id)},"1000")
        }
        
    })
}

//---------------- 事後集会情報取得
let jigo_qr_error = 0
const jigo_qr = (proc,jigo_id,user_id) => {

    let send_array = { jigo_id : jigo_id }

    axios.post(url+"Jigo_read", send_array, GlobalData.$ID_Token)
    .then(response => {
        let res = response.data
        if(res["status"] == 1){
            alert("エラーが発生しました。\n"+response.data["message"])
            return
        }else{

            param = {"proc":proc,"jigo_id":jigo_id,"user_id":user_id,"jigo":res}

            // 子コンポーネントをQRコード表示に切替
            content.value = UserJigoCode
            // 子コンポーネントを再レンダリング
            // Rendering_child()
        }
    })
    .catch(error => {
        if(jigo_qr_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "get_error";
            contentMessage.value = MessageModal
        }else{
            jigo_qr_error++
            setTimeout(function(){jigo_qr(proc,taiken_id,user_id)},"1000")
        }
        
    })
}

// スマホ用・検索フォームを開いたかどうかのフラグ
let Smart_search_open = ref(0)

// スマホ用・検索ボタン（icon_search.png）をクリックした時の動作
const Smart_search = function() {


    if(route.params.cmd == 'Jizen'){
        //事前説明会一覧の時は開かない
        return
    }
        // フォームオープンフラグ立て
        Smart_search_open.value = 1
        param = {all_bunrui_list:all_bunrui_list,search_param:search_param,cityname:cityname,
            
                gakusei_kbn_list:gakusei_kbn_list,
                gakusei_meisho_list:gakusei_meisho_list,
                gakusei_sanka:gakusei_sanka
         }
        content.value = UserSearchSmart
}

// スマホ用・Homeボタン（icon_home.png）をクリックした時の動作
const Smart_home = function() {
    // 検索フォームが開かれてるときは閉じる
    if( Smart_search_open.value == 1){
        
        if(route.params.cmd == "mypage"){
            router.replace("/"+cityname+"/Taiken")
        }else{
            loading_flg.value = true
            if(Object.keys(store.state.taiken).length){
                search_param = store.state.taiken
            }else{
                search_param = {shimekiri:0}
                store.state.taiken = {shimekiri:0}
            }
            // 表示している社協の分類1・2をチェック → 一覧表示へ
            Category_read("search")
    
        }
        Smart_search_open.value = 0
    }else{
        if(route.params.cmd == "home" || route.params.cmd == null){
            loading_flg.value = false
        }else{
            loading_flg.value = true

        }
        router.replace("/"+cityname+"/Taiken")
    }
}

// 家族登録後に登録ユーザに切り替える
const switch_user = () =>{

    cookies.set('switch_user', new_userid, '7d');  // 登録した切替対象ユーザーIDをcookieに設定する

    login_check()

    // 切替え後の画面表示
    switch(route.params.cmd){
        case "mypage":
            setTimeout(function(){Shakyo_code_check("mypage")}, "1500");
            break
        case "setting":
            setTimeout(function(){family_flg_get(GlobalData.$API_URL, GlobalData.user_id)}, "1500");
            break
        default:  
        
            console.log("enqete_shubetsu："+enqete_shubetsu)
            if(enqete_shubetsu != 1){
                setTimeout(function(){Category_read("search")}, "2000");
              //  router.push("/"+cityname+"/Taiken")
            }else{
                loading_flg.value = false
                router.push("/"+cityname+"/Taiken/enqete/1")
            }        
    }
}

// スマホ用・お知らせへの移動
const move_notification = () =>{

    // お知らせ画面以外でタップした時にセッションへコマンドとIDを保存して移動する
    if(route.params.cmd != "notification"){
        localStorage.setItem('return_cmd', route.params.cmd)
        localStorage.setItem('return_id', route.params.id)
        location.href=location.protocol+'//'+location.host+"/"+cityname+"/Taiken/notification"
    }
}

// Q&Aを開く
const qanda_open = () =>{

    let url = "https://zest-newsprint-e3e.notion.site/Q-A-175c0be34f8f801998fac72f169fb66b"
    window.open(url,"_blank")
}
//-------------- URLが変わった時に対応する処理を起動するためのフック -----------------
const wt = watch(route, () => {
    param = { cmd:route.params.cmd, id:route.params.id }
    call(param)
    
    console.log(param)
})

//-------------- URLに応じた処理のコンポーネントを呼び出す -------------------
let cmd = ""
const call = function(proc) {
    if(GlobalData.user_id != null){
        setTimeout(function(){mail_rireki_read(proc.cmd)}, "1000");
        //setTimeout(function(){Rightbar_setting()},"1000")
    }

    console.log(proc.cmd)

    let type = "tab_detail"
    switch(proc.cmd) {
        case "detail":  //------------- 詳細表示
            //alert("detail")

            loading_flg.value = true
            
            Category_read(proc.cmd)
            select_date.length = 0
            // 初期表示のタブを指定
            type = "tab_detail"
            if(proc.type){
                type = proc.type
            }
            //param = { program:taiken }

            // 自分の実績や祝日リストが取れていない場合は少し待つ

            console.log("詳細読み込み開始")
            if(jisseki_buf.length == 0){
                setTimeout(function(){taiken_read_buf(route.params.id,type)},"100")
            }else if(holiday_list.length == 0){
                setTimeout(function(){taiken_read(route.params.id,type)},"1000")
            }else{
                taiken_read(route.params.id,type)
            }

            break
        case "pg_moshikomi_ok":
            // UserPgShosaiより
            // 申込可能なら左サイドバーの申込ボタンを表示
            
            param_left = {header_logo:header_logo,
                header_title1:header_title1,
                header_title2:header_title2,
                title_style1:title_style1_pc.value,
                title_style2:title_style2_pc.value,
                moshikomi_ok:1}
            contentLeft.value = UserPgLeftbar
                displayStatus_left.value = false
                nextTick(() => {
                    displayStatus_left.value = true
                })

            break
        case "shosai_moshikomi":
            // 左サイドバーから申込ボタンを押したとき
            comp.value.moushikomi_set()

            break
        case "search":   //------------ 検索
            // 一覧のページ数（PCのみ）を初期化
            store.state.current_page = 1

            loading_flg.value = true
            let shimekiri = 0
            if(proc.shimekiri0 ){
                shimekiri  = proc.shimekiri0
            }


            search_param = { bunrui1:proc.bunrui10, bunrui2:proc.bunrui20, keyword:proc.keyword0,
                             kaisai_date:proc.kaisai_date0, joken:proc.joken0 , shimekiri:shimekiri}


            store.state.taiken = search_param

            setTimeout(function(){Category_read(proc.cmd)}, "1000");
            
            Smart_search_open.value = 0
            
            break
        case "Jizen": // ---------- 事前説明会一覧

            loading_flg.value = true
            
            setTimeout(function(){Shakyo_code_check(proc.cmd)}, "2000");
            break
        
        case "moushikomi":  //------------ 申込み内容確認
            shosai = proc.shosai
            sub = proc.sub
            select_date = proc.select_date
            select_date_sub = proc.select_date_sub

            user_jisseki_read() // 参加するユーザーの実績を取得
            break
        case "toroku":  //------------- 申込み内容をDBへ登録する

            // キャンセル待ち申込フラグ取得
            moshikomi_cancel_wait = proc.cancel_wait_flg
            facility_taiken_id =  proc.jisseki.taiken_id  // 申込完了後の受入先へのメール送信時に使用する体験プログラムID
            // 事前説明会をキャンセルするかどうかのフラグも追加
            Jisseki_add(proc.jisseki,proc.jizen_set_flg,proc.user_id,proc.cancel_jizen_id,proc.message_title,proc.message_honbun,proc.taiken_name,proc.user_name,proc.jizen_moushikomi_list)
            break
        case "toroku_jizen":  //------------- 事前説明会のみを申込む
                // キャンセルする事前説明会がある場合は先にキャンセル
                if(proc.cancel_jizen_id != ""){
                    Jizen_cancel_1(proc.moshikomi_pg,proc.user_id,proc.cancel_jizen_id)

                }else{
                    Jizen_jisseki_add(proc.moshikomi_pg,proc.user_id,proc.cancel_jizen_id)

                }
            break
        case "mypage":    //----------- マイページ一覧画面
            login_check()
            loading_flg.value = true

            //setTimeout(function(){my_jisseki()}, "1000");
            setTimeout(function(){Shakyo_code_check("mypage")}, "2000");
            
            break
        case "myshosai":  //----------- マイページ詳細画面
            login_check()
            taiken_read(proc.program.taiken_id,proc.cmd,proc.program)
            title = "マイ体験プログラム詳細"
            break
        case "setting":  //----------- マイページ設定画面
            title = "設定"
            login_check()
            // 設定画面に家族フラグを表示するための修正
            setTimeout(function(){family_flg_get(GlobalData.$API_URL, GlobalData.user_id)}, "1500");
                
            break;
        case "profile":  //----------- プロフィール編集
            login_check()
            user_read(proc.cmd)
            break
        case "cancel":   //-------------- 体験プログラムのキャンセル
            cancel(proc.program_id, proc.update_user)
            break
        case "Readcode":   //-------------- 二次元コードを読み込む画面を表示
            title = "二次元コード読取"
            content.value = UserMyCode
            contentLeft.value = Leftbar
            break
        case "showcode":   //-------------- 二次元コードを表示する
            if(proc.proc == "checkjizen"){
                // 事前説明会のQRコード生成画面への切替処理
                jizen_qr(proc.proc,proc.pg_id,proc.user_id)
            } else if(proc.proc == "checktaiken") {
                // 体験プログラムのQRコード生成画面への切替処理
                taiken_qr(proc.proc,proc.pg_id,proc.user_id)
            } else if(proc.proc == "checkjigo") {
                // 事後集会のQRコード生成画面への切替処理
                jigo_qr(proc.proc,proc.pg_id,proc.user_id)
            }
            break
        case "mypage_scroll_position" :
            // マイページのスクロール位置を保存する
            mypage_scroll = document.querySelector("#vy_main").scrollTop
            break
        case "checktaiken":  //-------------- チェックイン（体験）
            login_check()
            axios.post(url+"Shakyo_read", 
                {shakyo:route.params.shakyo}
                ).then(response => {

                // 事前説明会を実施するか確認。しないならそのまま体験プログラムのチェックインへ。
                if(response["data"].jizen_jisshi == 1){
                    
                    // チェックイン機能を利用するか確認。しないならここで終了。
                    checkin_flg.value = response["data"].checkin_flg
                    if(checkin_flg.value == 1){
                        axios.post(url+"Taiken_read", {taiken_id:proc.id})
                        .then(response => {
                            let taiken_jizen_no = response.data.jizenkensyu_no

                            if(taiken_jizen_no != [] && taiken_jizen_no != "" && taiken_jizen_no != null){
                                Jizen_jisseki_check(taiken_jizen_no,proc.id)
                            }else{
                                checkin(proc.id,1)
                            }
                        })
                        .catch(error => {
                            
                        })
                    }else{
                        loading_flg.value = false
                        message.value = "この社協では、二次元コードによるチェックイン機能を利用できません。";
                        message_cat.value = 0;
                        message_flag.value = true;
                        message_method.value = "checkin_flg_end";
                        contentMessage.value = MessageModal
                    }
                }else{
                    checkin(proc.id,1)
                }
            })
            .catch(error => {
                
            })
            break
        case "checkjizen":  //-------------- チェックイン（事前説明会）

            login_check()
            axios.post(url+"Shakyo_read", 
                {shakyo:route.params.shakyo}
                ).then(response => {
                
                // チェックイン機能を利用するか確認。しないならここで終了。
                checkin_flg.value = response["data"].checkin_flg
                if(checkin_flg.value == 1){
                    // チェックイン前に事前説明会の種類を取得
                    axios.post(url+"Jizen_read", {jizen_id:proc.id})
                    .then(response => {

                        let syurui = response.data.syurui
                        // 動画視聴期間は種類3（動画視聴）のみ利用する。未入力であれば日付を問わずチェックインOK
                        let kensyu_date = response.data.kensyu_date // 開催日または動画視聴期間（至）

                        if(syurui == '4' || syurui == '5'){
                            // チェックイン処理へ
                            
                            // 今日の日付（参加日）
                            const today = new Date()
                            let set_date = new Date(today);
                            set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
                            set_date = new Date(set_date);

                            let set_jisseki = {"program_kbn":2,"shubetsu":2,"kbn":1,"jizen_name":response.data.jizen_name,'tokusyu':'on'}
                            
                            setTimeout(function(){

                                // 自分の市区町村コードと説明会の市区町村コードが違う場合
                                if(choson_code != response.data.choson_code){
                                    loading_flg.value = false
                                    message.value = "所属社協が違うため、この特殊説明会は受けられません。";
                                    message_cat.value = 0;
                                    message_flag.value = true;
                                    message_method.value = "checkin_non_kensyu";
                                    contentMessage.value = MessageModal
                                }else{
                                    set_checkin(set_jisseki,proc.id,2,set_date)
                                }
                            },"1000")
                            
                        }else{
                            checkin(proc.id,2,kensyu_date)
                        }
                            })
                            .catch(error => {
                                
                                
                                
                            })
                }else{
                    loading_flg.value = false
                    message.value = "この社協では、二次元コードによるチェックイン機能を利用できません。";
                    message_cat.value = 0;
                    message_flag.value = true;
                    message_method.value = "checkin_flg_end";
                    contentMessage.value = MessageModal
                }
            })
            .catch(error => {
                
            })
            break
            
        case "checkjigo":  //-------------- チェックイン（事後集会）
            login_check()
            axios.post(url+"Shakyo_read", 
                {shakyo:route.params.shakyo}
                ).then(response => {
                
                // チェックイン機能を利用するか確認。しないならここで終了。
                checkin_flg.value = response["data"].checkin_flg
                if(checkin_flg.value == 1){
                    checkin(proc.id,3)
                }else{
                    loading_flg.value = false
                    message.value = "この社協では、二次元コードによるチェックイン機能を利用できません。";
                    message_cat.value = 0;
                    message_flag.value = true;
                    message_method.value = "checkin_flg_end";
                    contentMessage.value = MessageModal
                }
            })
            .catch(error => {
                
            })
            break
        case "checkio":  //-------------- 疑似的チェックイン／アウト
            //alert("enter checkio")
            checkio(GlobalData.user_id, proc.kbn, proc.id, proc.date, proc.start)
            break
        case "quest":    //-------------- アンケート、感想文の起動
            quest_open(proc.program)
            break
        
        case "quest_update":    //-------------- アンケート、感想文の提出
            quest_check(proc.program_id,proc.moshikomi_count)
            break
        case "cert":     //-------------- 参加証明のダウンロード
            cert_check(proc.program_id,proc.syomei_count,proc.moshikomi_count)
            break
        case "login":    //-------------- ログイン
            title = "ログイン"
            param = {cmd:proc.cmd} //どこの画面からログインしたかを明示的にする
            content.value = UserMailLogin
            
            param_left = {header_logo:header_logo,
                header_title1:header_title1,
                header_title2:header_title2,
                title_style1:title_style1_pc.value,
                title_style2:title_style2_pc.value}
            contentLeft.value = Leftbar
            break
        case "logout":   //-------------- ログアウト
            param = { program:taiken }
            title = "体験プログラム一覧"
            
            select_date.length = 0
            logout(cityname)
            //handleSignOut(cityname)
            
            setTimeout(function(){Rightbar_setting()},"1000")
            break
        
        case "renewal":    //-------------- パスワード変更
            setTimeout(function(){Rightbar_setting()},"1000")
            user_read(proc.cmd)
            param = {}
            title = "パスワード変更"
            content.value = UserRenewal
            
            param_left = {header_logo:header_logo,
                header_title1:header_title1,
                header_title2:header_title2,
                title_style1:title_style1_pc.value,
                title_style2:title_style2_pc.value}
            contentLeft.value = UserMyLeftbar
            break

        case "renewalcode":    //-------------- パスワード変更(コード入力)
            setTimeout(function(){Rightbar_setting()},"1000")
            param = {}
            title = "コード入力"
            content.value = UserRenewalCode
            
            param_left = {header_logo:header_logo,
                header_title1:header_title1,
                header_title2:header_title2,
                title_style1:title_style1_pc.value,
                title_style2:title_style2_pc.value}
            contentLeft.value = UserMyLeftbar
            break
        
        case "renewal_complete": //-------------- パスワード変更(完了)
            mail_renewal_create()
            break
        
        case "forgot":    //-------------- パスワードを忘れた場合
            param = {"mail_list":mail_list[0]}
            title = "パスワードの再設定"
            content.value = UserMailRenewal
            
            param_left = {header_logo:header_logo,
                header_title1:header_title1,
                header_title2:header_title2,
                title_style1:title_style1_pc.value,
                title_style2:title_style2_pc.value}
            contentLeft.value = Leftbar
            break
        
        case "forgotcode":    //-------------- パスワードを忘れた場合(コード入力)
            
            title = "コード入力"
            content.value = UserMailRenewalCode
            
            param_left = {header_logo:header_logo,
                header_title1:header_title1,
                header_title2:header_title2,
                title_style1:title_style1_pc.value,
                title_style2:title_style2_pc.value}
            contentLeft.value = Leftbar
            break
        
        case "forgot_complete": //-------------- パスワードを忘れた場合(完了)
            //メール送信の必要がない場合は送らずにマイページへ
            router.push("/"+cityname+"/Taiken/mypage")
            break

        case "social_login": // ソーシャルログインボタンタップ時

            // ローディングアイコンを表示
            loading_flg.value = true
            break
        case "user_toroku":  //---------- プロフィール登録確認

            login_check()
            
           // setTimeout(function(){Rightbar_setting()},"1000")
            setTimeout(function(){toroku_disp()},"1500")
            break
        case "multipleprofile":  //---------- プロフィール登録確認(右メニューからの起動)
            // ローディングアイコンを表示
            loading_flg.value = true

            login_check()
            // プロフィール登録画面を表示する。
            setTimeout(function(){multipleprofile_disp(true)},"1500")
            break
        case "multipleprofile_switch":  //---------- ユーザー切替え画面
            // ユーザー切替え画面を表示する。
            multipleprofile_switch(proc.id)
            break
        case "switch_user":  //---------- ユーザー切替え処理
            multipleprofile_close()   // 切替え画面を非表示にする。

            if(proc.id == GlobalData.user_id ) return;   // ユーザーの切替えをしていない時は、戻る

            // ローディングアイコン表示
            loading_flg.value = true
            if(proc.role == true){
                cookies.remove('switch_user');  // アカウントユーザーは、cookieには登録しない。
            } else {
                cookies.set('switch_user', proc.id, '7d');  // 切替え画面から取得した切替対象ユーザーIDをcookieに設定する
            }

            login_check()

            // 切替え後の画面表示
            switch(route.params.cmd){
                case "mypage":
                    setTimeout(function(){Shakyo_code_check("mypage")}, "1500");
                    break
                case "setting":
                    setTimeout(function(){family_flg_get(GlobalData.$API_URL, GlobalData.user_id)}, "1500");
                    break
                case "notification":
                    // お知らせ
                    title = "お知らせ"
                    setTimeout(function(){mail_rireki_read(route.params.cmd)}, "1000");
                    break
                case "Jizen":
                    loading_flg.value = true
                    setTimeout(function(){Shakyo_code_check("Jizen")}, "2000");
                    break
                default:
                    setTimeout(function(){Category_read("search")}, "2000");
                    setTimeout(function(){router.push("/"+cityname+"/Taiken")}, "1000"); // リロード
                    // setTimeout(function(){router.push("/"+cityname+"/Taiken").then(() => {router.go(0) })}, "1000"); // リロード
                    break
            }

            // ローディングアイコン非表示   ここでfalseにするとローディング画面が一瞬で消える
            // loading_flg.value = false

            break
        case 'multipleUser_delete':  //---------- アカウント削除
            multipleUser_Delete(proc.id, proc.role)
            break
        // プロフィール登録画面を表示する。
        case "user_joho":    //---------- 会員情報登録（UserToroku.vueより）
            loading_flg.value = true
            multipleprofile = proc.multipleprofile  // 複数ユーザー対応  複数ユーザーの新規登録時:True

            user_check(proc.user_data)
            break
        case "user_koshin":    //---------- 会員情報更新（UserToroku.vueより）
            user_update(proc.user_data)
            break
        case "user_family_koshin":    //---------- 会員情報(家族フラグ)更新
            user_family_update(proc.user_data)
            break
        case "user_signin":  //---------- アカウント登録
            render.value = render.value + 1
            title = "新規ユーザー登録"
            content.value = UserSignin
            
            param_left = {header_logo:header_logo,
                header_title1:header_title1,
                header_title2:header_title2,
                title_style1:title_style1_pc.value,
                title_style2:title_style2_pc.value}
            contentLeft.value = Leftbar
            setTimeout(function(){Rightbar_setting()},"1000")
            break
        
        case 'user_delete':  //---------- アカウント削除
            User_Delete_logout();
            break
        case "Policy":  //---------- プライバシーポリシー
            title = "プライバシーポリシー"
            content.value = UserPolicy
            
            param_left = {header_logo:header_logo,
                header_title1:header_title1,
                header_title2:header_title2,
                title_style1:title_style1_pc.value,
                title_style2:title_style2_pc.value}
            contentLeft.value = Leftbar
            break
        case "Condition":  //---------- 利用規約
            title = "利用規約"
            content.value = UserCondition
            
            param_left = {header_logo:header_logo,
                header_title1:header_title1,
                header_title2:header_title2,
                title_style1:title_style1_pc.value,
                title_style2:title_style2_pc.value}
            contentLeft.value = Leftbar
            break
        case "page_scroll"://----------ページトップまでスクロール
            Page_scroll(0)
            break
        
        case "return_smart"://----------スマホの検索入力から戻ったとき
        
            loading_flg.value = true
            if(route.params.cmd == "user_toroku"){
                // ユーザー情報が未登録の場合
                setTimeout(function(){toroku_disp()},"1000")

            }else if(route.params.cmd == "detail"){
                param = { cmd:route.params.cmd, id:route.params.id }
                call(param)

            }else if(route.params.cmd == "mypage"){
                my_jisseki()
            }else{
                /*
                render.value = render.value + 1
                title = "体験プログラム一覧"
                param = { program:taiken }
                content.value = UserPgIchiran*/
                param = {cmd:""}
                call(param)
               // setTimeout(function(){Rightbar_setting()},"500") 
                
            }
            Smart_search_open.value = 0
            loading_flg.value = false
            break
        
        
        case "email":  //-------------- 疑似的メール送信（テスト用）
            login_check()
            setTimeout(function(){mail_create()}, "1000");
            break
        
        case "email_rireki":  //-------------- 疑似的メール送信履歴記録（テスト用）
            login_check()
            setTimeout(function(){mail_rireki_add("test","test","test",false)}, "1000");
            break
        
        case "enqete":
            login_check()
            // アンケート回答画面への移動
            loading_flg.value = true
            title = "アンケート"
            /*
            let enqete_file_name = "enqete/enqete"+route.params.id+".csv"

            setTimeout(function(){Form_read(enqete_file_name,1,0,route.params.id,proc.moshikomi_count)}, "1000");
            */
           
            // アンケート回答画面への移動
            setTimeout(function(){Form_Dynamo_read(1,route.params.id,0)}, "1000");

            break
            
        case "report":
            // 報告書回答画面への移動

            title = "活動報告書"
            /*
            let file_name = "report/report"+proc.form_no+".csv"
            setTimeout(function(){Form_read(file_name,2,proc.program_id,proc.form_no,proc.moshikomi_count)}, "1000");
            */
            // 報告書回答画面への移動
            setTimeout(function(){Form_Dynamo_read(2,proc.form_no,proc.program_id)}, "1000");


            break
            
        case "cr_answer":
            // ローディングアイコン表示
            loading_flg.value = true
            login_check()
            // アンケート・報告書の回答入力
            console.log(proc.form_id)
            //d(answer_list,form_syurui,form_no,form_title,program_id,taikenuser_id,form_id)
            setTimeout(function(){Form_answer_add(proc.answer_list,
                                                  proc.form_syurui,
                                                  proc.form_no,
                                                  proc.form_title,
                                                  proc.program_id,
                                                  GlobalData.user_id,
                                                  proc.form_id,
                                                  proc.mail_answer,
                                                  proc.moshikomi_count)}, "1000");
            break

        case "notification":
            // お知らせ
            title = "お知らせ"
            // ローディングアイコン表示
            loading_flg.value = true
            setTimeout(function(){mail_rireki_read(proc.cmd)}, "1000");

            break

        case "loading_start":
            // ローディングアイコン表示
            loading_flg.value = true
            break
        case "loading_end":
            // ローディングアイコン解除（画面リロード）
            loading_flg.value = false
            location.reload()
            break
        case "loading_end_noreload":
            // ローディングアイコン解除
            loading_flg.value = false
            break
            
        case "scroll_position_reset" :
            // スクロール位置をリセット
            list_scrollpos = 0
            Page_scroll_list(list_scrollpos)
            break;
        case "scroll_position" :
            // 一覧のスクロール位置を保存する

            // スマホ・PCのどちらか、横幅でチェック（縦の位置の検知がそれぞれ違うため）
            const isSP = window.matchMedia("(max-width: 960px)").matches;
            
            if (isSP) {
                // スマホ
                list_scrollpos = window.scrollY || document.documentElement.scrollTop;
            } else {
                // PC
                list_scrollpos = document.querySelector("#vy_main").scrollTop;
            }
            break;
        case "program":
        case "Program":

            // 体験プログラム一覧・初期表示（パターン１の時のみ）
            loading_flg.value = true
            if(Object.keys(store.state.taiken).length){
                search_param = store.state.taiken
            }else{
                search_param = {shimekiri:0}
                store.state.taiken = {shimekiri:0}
            }
            // 表示している社協の分類1・2をチェック → 一覧表示へ
            setTimeout(function(){
                Category_read("search")
            }, "500");
            setTimeout(function(){Rightbar_setting()},"1000")
            // ユーザーの所属社協をチェック
            setTimeout(function(){
                Shakyo_code_check("home")
            }, "2000");
            break
        case "render_Smart":  //------------- スマホの下部メニューの再描画
            console.log("route.params.cmd:",route.params.cmd)
            console.log("GlobalData.$User_email:",GlobalData.$User_email)
            render_Smart.value++
            break
        case "home":  //------------- 初期表示
            
        default :
            login_check()
            axios.post(url+"Shakyo_read", 
                {shakyo:route.params.shakyo}
                ).then(response => {
                
                GlobalData.$taiken_flow = response["data"].flow
                    
                // ユーザー登録後アンケートの実施状況確認
                if(response["data"].enqete_shubetsu == 1){
                    setTimeout(function(){Form_answer_check()},"1000")
                    GlobalData.enqete_flg = 2
                }else{
                    // 回答の必要なし
                    GlobalData.enqete_flg = 2
                }

                // 体験申込の流れがケース1の場合
                if(GlobalData.$taiken_flow == 1){
                    
                    let today = new Date()
                    let flow_end_date = new Date(response["data"].flow_end_date +" "+response["data"].flow_end_time)

                    console.log(today+":"+flow_end_date)
                    // 今日がホーム画面の初期表示変更日時よりも前なら事前説明会一覧へ
                    if (flow_end_date >= today) {
                        router.push("/"+cityname+"/Taiken/Jizen")
                    }else{
                        // 変更日時よりも後ならプログラム一覧へ
                        router.push("/"+cityname+"/Taiken/Program")
                    }
                }else{
                 //   loading_flg.value = true
                    if(Object.keys(store.state.taiken).length){
                        search_param = store.state.taiken
                    }else{
                        search_param = {shimekiri:0}
                        store.state.taiken = {shimekiri:0}
                    }
                    // 表示している社協の分類1・2をチェック → 一覧表示へ
                    setTimeout(function(){
                        Category_read("search")
                    }, "500");
                    setTimeout(function(){Rightbar_setting()},"1000")
                    // ユーザーの所属社協をチェック
                    setTimeout(function(){
                        Shakyo_code_check("home")
                    }, "2000");
                }
            })
            .catch(error => {
                
            })
            
            break            
    }
    
}

/* 初期処理 */

    // この社協における体験プログラムの申込者をすべて取得する
    let Sankasha = []
        axios.post(url + "Jisseki_Userread",
        {"program_kbn":1,"choson_code":route.params.shakyo})//ヘッダーを追加（IDトークンを送信）
        .then(response => {
            //正常な結果が返ってきた場合の処理
            // response.data["status"]・・・status=0の時は正常終了、status=1のときは異常終了（データが取得できなかった等）
            // response.data["message"]・・・API処理結果に付随するメッセージ。主にstatus=1（異常終了）の時に利用する

                console.log(response.data)
            if(response.data["status"] == 1){
                alert("エラーが発生しました。\n"+response.data["message"])
            }else{
              Sankasha = response.data
            }
            
            // 申込者を取得出来たら他の処理へ
            shakyo_read()
        })
        .catch(error => {  
              message.value = error + GlobalData.$axios_error;
              message_method.value = "get_error";
              message_cat.value = 0;
              message_flag.value = true;
              contentMessage.value = MessageModal
        })

</script>
